var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLawFirmAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M77.66,242c-95.18,55-95.17,144,0,199s249.49,55,344.67,0,95.17-144,0-199S172.84,187,77.66,242Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-3",
    d: "M366.14,204.88c19.12,11,19.12,28.94,0,40s-50.12,11-69.24,0-19.12-28.94,0-40S347,193.84,366.14,204.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 408.51,
    cy: 352.3,
    rx: 62.93,
    ry: 36.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 250,
    cy: 432.93,
    rx: 62.93,
    ry: 36.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 78.95,
    cy: 352.3,
    rx: 62.93,
    ry: 36.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "337.61 270.96 184.28 359.48 66.6 291.53 219.93 203.02 337.61 270.96",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9,253.39q-6.4,4.59-12,9.43a100.59,100.59,0,0,0-9.58-26c-5-9-10.59-16.21-14.37-21.4-8.74-12,4.45-18.25,15-12.66S55,218.22,57.85,235.25C58.6,239.83,59.66,247.94,59.9,253.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.11,205.82a.64.64,0,0,0-.89.14.62.62,0,0,0,.14.89c11.56,8.49,21.27,23.53,23.35,50.39.41-.29.81-.63,1.22-.92C53.67,229.46,43.74,214.36,32.11,205.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,257.78a152.2,152.2,0,0,0-24.29,23.39,9,9,0,0,1-2.49-2.34,9.06,9.06,0,0,1-1.5-3.87c-.27-2,0-4.11-.87-5.88-1.22-2.37-4.12-3.23-6.7-3.91s-5.47-1.65-6.52-4.1c-.93-2.15-.32-5.08.74-7.06s2.57-4.14,2.19-6.51c-.33-2-2-3.53-3.48-4.92s-3.07-3-3.17-5.07a5.66,5.66,0,0,1,2.59-4.68,10.71,10.71,0,0,1,9.32-1.09c3.16,1,6,2.92,9,4.2s6.28.15,9.46.83l.14,0c3.14.7,6.44,1.94,7.56,5.28s-.29,7.3,1.63,10.21c1.08,1.64,2.89,2.34,4.47,3.38a5.57,5.57,0,0,1,1.84,1.92A1.24,1.24,0,0,1,54,257.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,255a.33.33,0,0,0-.14-.19c-7.71-12.17-20.43-18.39-24.79-19.58a.45.45,0,0,0-.56.32.46.46,0,0,0,.32.57C19,237.29,30.8,243,38.4,254.23a25.41,25.41,0,0,0-20.32.76.47.47,0,0,0-.18.63.48.48,0,0,0,.37.23.41.41,0,0,0,.26-.07,24.61,24.61,0,0,1,20.75-.23,42.46,42.46,0,0,1,4.58,10.79c.25-.23.57-.54.83-.76A43.07,43.07,0,0,0,40,255Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.25,221.36c-4.72,7.76-13.5,12.35-19.79,26.56a70.25,70.25,0,0,0-4,12.08,102.89,102.89,0,0,0-2,10.46c-1.36-1.34-2.76-2.68-4.21-4q-3.33-3.06-6.95-6a93,93,0,0,1,5-29.42c5.24-15,15.86-22.66,22.58-23.89C484.39,205.76,492.41,211.24,486.25,221.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.25,213c-10.56,7.9-23.19,28.51-22.84,52.7l-1-.85c0-24.08,12.62-44.53,23.2-52.46a.53.53,0,0,1,.67,0A.38.38,0,0,1,478.25,213Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.29,264.25a54.17,54.17,0,0,0-8.91,10.21c-1.26-1.34-2.56-2.68-3.9-4s-2.76-2.68-4.21-4a43.14,43.14,0,0,1,10.19-18.55,33.35,33.35,0,0,1,6.7-5.68c6.8-4.12,16.7-6.3,18.9,0S482,256.21,473.29,264.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,241.77c-6.91,2.77-19.92,15.86-24.93,28.25l-.74-.71c5.2-12.56,18.15-25.41,25.31-28.28a.48.48,0,0,1,.62.19A.41.41,0,0,1,485,241.77Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scale--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scales--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,199.89c.22,15-12.55,22.9-28,22.9s-28.05-7.91-28.05-22.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,211.34c10.95-6.33,10.95-16.58,0-22.9s-28.71-6.33-39.67,0-10.95,16.57,0,22.9S397.86,217.66,408.82,211.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,184.7c7.31,0,14.18,1.63,19.33,4.6,5,2.88,7.71,6.64,7.71,10.59s-2.74,7.71-7.71,10.58c-5.15,3-12,4.61-19.33,4.61s-14.19-1.64-19.34-4.61c-5-2.87-7.71-6.63-7.71-10.58s2.74-7.71,7.71-10.59c5.15-3,12-4.6,19.34-4.6m0-1c-7.18,0-14.36,1.58-19.84,4.74-10.95,6.32-10.95,16.57,0,22.9,5.48,3.16,12.66,4.74,19.84,4.74s14.35-1.58,19.83-4.74c10.95-6.33,10.95-16.58,0-22.9-5.48-3.16-12.66-4.74-19.83-4.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.39,212.08c-10.53,5.31-26.27,5.31-36.81,0-3.74-4.41-2.45-9.89,3.91-13.56,8-4.63,21-4.63,29,0C409.84,202.19,411.13,207.66,407.39,212.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.22,216h0a.49.49,0,0,0,.45-.53l-7.24-78.67a.49.49,0,0,0-.53-.44.48.48,0,0,0-.44.53l7.24,78.67A.48.48,0,0,0,396.22,216Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.91,196.17a.49.49,0,0,0,.44-.29l27.08-58.81a.49.49,0,1,0-.89-.41l-27.07,58.82a.47.47,0,0,0,.23.64A.54.54,0,0,0,361.91,196.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.82,188.93a.35.35,0,0,0,.17,0,.48.48,0,0,0,.28-.63l-19.83-51.57a.49.49,0,1,0-.91.35l19.83,51.57A.49.49,0,0,0,408.82,188.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.41,134.73c.21,15-12.56,22.9-28.05,22.9s-28-7.9-28-22.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.19,146.18c11-6.32,11-16.58,0-22.9s-28.71-6.32-39.66,0-10.95,16.58,0,22.9S285.24,152.5,296.19,146.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.36,119.54c7.32,0,14.19,1.63,19.33,4.61,5,2.87,7.72,6.63,7.72,10.58s-2.74,7.71-7.72,10.58c-5.14,3-12,4.61-19.33,4.61s-14.18-1.63-19.33-4.61c-5-2.87-7.71-6.63-7.71-10.58s2.74-7.71,7.71-10.58c5.15-3,12-4.61,19.33-4.61m0-1c-7.17,0-14.35,1.58-19.83,4.74-10.95,6.32-10.95,16.58,0,22.9,5.48,3.16,12.66,4.74,19.83,4.74s14.36-1.58,19.83-4.74c11-6.32,11-16.58,0-22.9-5.47-3.16-12.65-4.74-19.83-4.74Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.77,146.92c-10.54,5.31-26.28,5.31-36.81,0-3.74-4.41-2.45-9.89,3.91-13.56,8-4.62,21-4.62,29,0C297.22,137,298.51,142.51,294.77,146.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.6,150.87h0a.48.48,0,0,0,.44-.53l-7.23-78.67a.5.5,0,0,0-.53-.44.48.48,0,0,0-.44.53l7.23,78.67A.5.5,0,0,0,283.6,150.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.28,131a.47.47,0,0,0,.44-.28l27.09-58.82a.49.49,0,0,0-.89-.41l-27.08,58.82a.49.49,0,0,0,.24.65A.45.45,0,0,0,249.28,131Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.19,123.77a.39.39,0,0,0,.18,0,.48.48,0,0,0,.28-.63L276.82,71.53a.49.49,0,0,0-.63-.28.48.48,0,0,0-.28.63l19.83,51.57A.48.48,0,0,0,296.19,123.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,63.74c0,2.43,1.55,5.31,3.33,6.33a1.57,1.57,0,0,0,1.52.2,2.56,2.56,0,0,0,.83-2.24,8.67,8.67,0,0,0-1.29-4.29h2.23a10.42,10.42,0,0,1,1,4.29A4.32,4.32,0,0,1,278.87,72a2.91,2.91,0,0,1-1.47.39,4,4,0,0,1-2-.59c-2.38-1.37-4.26-4.88-4.31-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Base--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.05,205.79c-10.59-6.11-27.75-6.11-38.34,0-5.29,3.06-7.92,7.06-7.91,11.07V221c0,4,2.62,8,7.91,11.07,10.59,6.11,27.75,6.11,38.34,0C356.34,229,359,225,359,221v-4.14C359,212.85,356.34,208.85,351.05,205.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.05,205.79c-10.59-6.11-27.75-6.11-38.34,0-5.29,3.06-7.92,7.06-7.91,11.07V221c0,4,2.62,8,7.91,11.07,10.59,6.11,27.75,6.11,38.34,0C356.34,229,359,225,359,221v-4.14C359,212.85,356.34,208.85,351.05,205.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.71,205.79c-10.58,6.11-10.58,16,0,22.13s27.75,6.11,38.34,0,10.58-16,0-22.13S323.3,199.68,312.71,205.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.72,200.65c-8.75-5.06-22.93-5.06-31.68,0-4.38,2.52-6.55,5.83-6.54,9.14v6.1c0,3.31,2.16,6.62,6.54,9.15,8.75,5.05,22.93,5.05,31.68,0,4.38-2.53,6.55-5.84,6.54-9.15v-6.1C354.27,206.48,352.1,203.17,347.72,200.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,200.65c-8.75,5-8.75,13.24,0,18.29s22.93,5.05,31.68,0,8.75-13.24,0-18.29S324.79,195.59,316,200.65Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.22,128.48h2a6.28,6.28,0,0,0,0,.64c0,2.46,1.53,5.41,3.33,6.46a1.62,1.62,0,0,0,1.53.2,2.57,2.57,0,0,0,.83-2.25,7.81,7.81,0,0,0-.52-2.67h2.07a9.62,9.62,0,0,1,.41,2.67,4.33,4.33,0,0,1-1.81,3.94,2.91,2.91,0,0,1-1.47.39,4.06,4.06,0,0,1-2-.59c-2.42-1.4-4.31-5-4.31-8.15C384.19,128.9,384.2,128.69,384.22,128.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,205.83c0-2.62-1.74-5.25-5.21-7.25-6.94-4-18.18-4-25.12,0-3.47,2-5.2,4.63-5.2,7.25v2.1c0,2.63,1.73,5.25,5.2,7.25,6.94,4,18.18,4,25.12,0,3.47-2,5.21-4.62,5.21-7.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.44,198.58c-1.21-.78-3.09-3.85-3.95-8-2-9.66-2-25.15-.35-31H323.62c1.62,5.86,1.65,21.35-.35,31-.86,4.15-2.74,7.22-3.95,8h0c-3.47,2-5.2,4.63-5.2,7.25s1.73,5.25,5.2,7.25c6.94,4,18.18,4,25.12,0,3.47-2,5.21-4.63,5.21-7.25S347.91,200.58,344.44,198.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.07,163.07c0,3.75-.21,30.69-2.64,34.11s-5.19,3.69-7,6.63,1.07,7,5.48,8.34a5.38,5.38,0,0,1-1.36-2.81s2.92,3.45,9.48,2.81c-5.78-1-8.09-5.35-6.85-7.48s3.43-3,4.62-6.95c.93-3.06.91-34.15.91-34.15A15.37,15.37,0,0,1,327.07,163.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.71,163.49c.21,6.4.35,31.93,2.21,35,1.45,2.39,2.36,3.76,2.66,6.43s-2.09,5-3.86,5.56a8.71,8.71,0,0,0,4.42-1.63s-1.48,3-7.29,4.37c3.92.27,10.18-.85,13.65-5.22,2.94-3.7-.12-5.46-2.61-6.89s-3.77-2.73-5-6.12c-2.62-7.43-1.48-32.15-1.48-32.15A15.47,15.47,0,0,1,334.71,163.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.43,163.14a24.2,24.2,0,0,1,.71-3.57H323.62a24.2,24.2,0,0,1,.71,3.57A17.52,17.52,0,0,0,339.43,163.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324,161.82c-2.18-1.25-3.26-2.9-3.26-4.54s1.08-3.29,3.26-4.54a17.37,17.37,0,0,1,15.73,0c2.17,1.25,3.25,2.9,3.25,4.54s-1.08,3.29-3.25,4.54A17.37,17.37,0,0,1,324,161.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M342.25,155a7.34,7.34,0,0,0-2.5-2.22,17.37,17.37,0,0,0-15.73,0,7.29,7.29,0,0,0-2.51,2.22,5.67,5.67,0,0,0,3,3.51,16.35,16.35,0,0,0,14.8,0A5.67,5.67,0,0,0,342.25,155Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.48,157c-2-1.18-3.06-2.73-3.06-4.27s1-3.09,3.06-4.27a16.35,16.35,0,0,1,14.8,0c2,1.18,3.06,2.72,3.06,4.27s-1,3.09-3.06,4.27A16.35,16.35,0,0,1,324.48,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.6,150.49a6.93,6.93,0,0,0-2.32-2,16.35,16.35,0,0,0-14.8,0,7,7,0,0,0-2.32,2A5.29,5.29,0,0,0,325,153.8a15.32,15.32,0,0,0,13.86,0A5.29,5.29,0,0,0,341.6,150.49Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M325,152.16c-1.92-1.11-2.88-2.55-2.88-4s1-2.9,2.88-4a15.32,15.32,0,0,1,13.86,0c1.92,1.11,2.88,2.56,2.88,4s-1,2.89-2.88,4A15.32,15.32,0,0,1,325,152.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M340.89,145.93a6.68,6.68,0,0,0-2.08-1.78,15.32,15.32,0,0,0-13.86,0,6.79,6.79,0,0,0-2.08,1.78,5.1,5.1,0,0,0,2.54,2.86,14.32,14.32,0,0,0,12.94,0A5.1,5.1,0,0,0,340.89,145.93Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M340,156.52c1.5-1.16.48-3.88-.68-4.68,1.27-1.46.58-3.51-1-4.51a11.4,11.4,0,0,1-3.07,1.17c1.56,1,2.32,3.25,1,4.71,1.17.79,2.17,3.61.67,4.78,1.05.89,2.18,3.37.45,4.85a11.51,11.51,0,0,0,3-1.46C342.16,159.91,341.06,157.42,340,156.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.75,156.52c-1.5-1.16-.48-3.88.69-4.68-1.28-1.46-.59-3.51,1-4.51a11.4,11.4,0,0,0,3.07,1.17c-1.56,1-2.32,3.25-1,4.71-1.17.79-2.17,3.61-.67,4.78-1,.89-2.18,3.37-.45,4.85a11.51,11.51,0,0,1-3-1.46C321.6,159.91,322.7,157.42,323.75,156.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,140.67c-.42-.38-1.61-3.29-2-7.77-1.21-15.27-1.21-34.91-1.21-49.84h-8.86c0,14.92,0,34.51-1.21,49.79-.36,4.52-1.55,7.44-2,7.82a3.92,3.92,0,0,0-1.54,2.93c0,1.35.9,2.7,2.68,3.73a14.32,14.32,0,0,0,12.94,0c1.78-1,2.68-2.38,2.68-3.73A3.92,3.92,0,0,0,339.49,140.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M338.35,141.33c-1.28-2.06-2.23-3.43-2.62-8.48-.37-4.68-.06-48.34,0-49.79h-.61l-.8.25c0,7-.47,51.27.58,55.13s3.45,7.7.39,10.06a11.38,11.38,0,0,0,3.07-1.17C340.06,145.25,339.62,143.39,338.35,141.33Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.41,141.33c1.28-2.06,2.23-3.43,2.62-8.48.37-4.68.06-48.34,0-49.79h.61l.8.25c0,7,.47,51.27-.58,55.13s-3.45,7.7-.39,10.06a11.38,11.38,0,0,1-3.07-1.17C323.7,145.25,324.14,143.39,325.41,141.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M327.44,85.52a7.7,7.7,0,0,0,8.88,0c0-.79,0-1.6,0-2.46h-8.86C327.45,83.92,327.44,84.73,327.44,85.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M324.15,77.29a7.73,7.73,0,1,0,7.73-7.72A7.73,7.73,0,0,0,324.15,77.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.67,81.3a5.92,5.92,0,0,0,3.43-3.81,8.64,8.64,0,0,0,.17-3.58,8.5,8.5,0,0,0-.47-1.71,5.87,5.87,0,0,0-.36-.81,2.69,2.69,0,0,0-.34-.57,7.73,7.73,0,1,1-12,6.47C325,79.75,329.16,83.28,333.67,81.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.64,77.11c.75,2.07,1-.93,4.46-3.13,2.81-1.79,6.15-1.42,4.33-2.68-1.45-1-3.81-1-6,.19S325.08,75.55,325.64,77.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.42,67.26h0v8.17A76.44,76.44,0,0,1,339,80c7.38,5.63,13.83,12.57,20,19.85,4.38,5.22,8.53,10.7,12.93,16.11a8.09,8.09,0,0,0,.8,1.23,5.6,5.6,0,0,0,1.15,1.13c1.13,1.36,2.28,2.72,3.46,4a50.73,50.73,0,0,0,11.35,10.1l.86.5a9.42,9.42,0,0,0,3.38,1.17,6.42,6.42,0,0,0,5.16-1.54,6.28,6.28,0,0,0,1.54-2.22,9.06,9.06,0,0,0,.63-2.28,13.54,13.54,0,0,0-.17-4.24,17.86,17.86,0,0,0-1.2-3.86,17,17,0,0,0-2-3.51,10.71,10.71,0,0,0-3.19-2.84,6,6,0,0,0-2.31-.74,4.15,4.15,0,0,0-2.67.63,3.84,3.84,0,0,0-1,1,4.71,4.71,0,0,0-.59,1.16,6.55,6.55,0,0,0-.32,2.23,10.44,10.44,0,0,0,.91,4,9.55,9.55,0,0,0,2.3,3.32,5.23,5.23,0,0,0,1.89,1.11,3,3,0,0,0,1.25.11,2.53,2.53,0,0,0,1.21-.52.76.76,0,0,0-.85-1.25l-.07,0a1.07,1.07,0,0,1-1,0,3.36,3.36,0,0,1-1.13-.84,7.7,7.7,0,0,1-1.52-2.77,8.52,8.52,0,0,1-.44-3.11,3.72,3.72,0,0,1,.3-1.33,1.25,1.25,0,0,1,.58-.66,1.34,1.34,0,0,1,.81-.08,3.56,3.56,0,0,1,1.08.48,7.31,7.31,0,0,1,2,2.12,12.88,12.88,0,0,1,1.4,2.86,14.32,14.32,0,0,1,.73,3.11,9.44,9.44,0,0,1-.07,3,3.26,3.26,0,0,1-.94,1.89c-.83.64-2.16.47-4-.88a33.71,33.71,0,0,1-5.1-4.39c-1.55-1.56-3-3.24-4.45-5a3.66,3.66,0,0,0,.74-.91,5.79,5.79,0,0,0,.55-3.35,9.63,9.63,0,0,0-.76-2.76,6.4,6.4,0,0,0-1.56-2.28.26.26,0,0,0-.38,0,.25.25,0,0,0-.05.27v0a6.76,6.76,0,0,1,.37,2.35,8.21,8.21,0,0,1-.28,2.25,2.45,2.45,0,0,1-.79,1.45c-.13.07-.16,0-.15-.09s0-.11-.19-.19l-.15-.11c-2.1-2.72-4.15-5.52-6.21-8.34-2.73-3.66-5.48-7.35-8.34-11A25.8,25.8,0,0,0,361.4,88c-3.92-6.85-15.32-13-26-19.06-1-.6-2-1.17-3-1.72h0ZM347.54,78c3.18,1.9,8.22,5.32,11.55,9.57,2.16,2.76,2.77,4.67,2.93,5.71A127.23,127.23,0,0,0,347.54,78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.44,50a17.78,17.78,0,0,0,1.79,8,19.72,19.72,0,0,0,4.9,6.63,13.78,13.78,0,0,0,1.81,1.29c.57.34,1.17.68,1.78,1a23.21,23.21,0,0,0,3.85,1.48,26.9,26.9,0,0,0,8,.92c5.24-.16,10-1.13,14.6-1.55a48,48,0,0,1,13.46.46,52.47,52.47,0,0,1,17.79,7.23V67.25l-.21-.11c-11.38-6.59-24.5-15.09-28.77-12.57-2.38,1.42-3.13,4.33-3.33,6.64-4,.51-7.78,1.36-11.4,1.84l-.25-.11a4.32,4.32,0,0,1-1.59-.88,6.83,6.83,0,0,1-1.25-1.5,8.38,8.38,0,0,1-1-1.86,8.07,8.07,0,0,1-.53-2.11,4.16,4.16,0,0,1,0-1.06,1.11,1.11,0,0,1,.35-.8l.07,0a.26.26,0,0,0,.06-.37.28.28,0,0,0-.23-.11,1.81,1.81,0,0,0-1.28.87,5.08,5.08,0,0,0-.63,1.28,9.15,9.15,0,0,0-.46,2.74,11.77,11.77,0,0,0,.32,2.81,11.31,11.31,0,0,0,.5,1.45,18.8,18.8,0,0,1-2.92-.37,17.36,17.36,0,0,1-3-.94c-.49-.2-1-.43-1.45-.67a9,9,0,0,1-1.18-.74,14.94,14.94,0,0,1-3.93-4.73A13.38,13.38,0,0,1,268.67,50a6.05,6.05,0,0,1,.41-2.6,2,2,0,0,1,.53-.73.65.65,0,0,1,.46-.18,3.49,3.49,0,0,1,2.06,1,9.23,9.23,0,0,1,1.93,2.37,9,9,0,0,1,1.13,2.85,5,5,0,0,1-.08,2.68,1.54,1.54,0,0,1-.37.54.52.52,0,0,1-.23,0,1.29,1.29,0,0,1-.49-.11A7.4,7.4,0,0,1,271.6,54l0,0a.67.67,0,0,0-1.13.62,5.86,5.86,0,0,0,.81,1.88,5.12,5.12,0,0,0,1.56,1.59,4.26,4.26,0,0,0,1.2.52,3.08,3.08,0,0,0,1.56-.05,3.57,3.57,0,0,0,2.15-1.92,7.7,7.7,0,0,0,.54-4.44A12.47,12.47,0,0,0,277,48.28a13.38,13.38,0,0,0-2.44-3.38,9.11,9.11,0,0,0-1.8-1.38,6,6,0,0,0-2.48-.8,4.5,4.5,0,0,0-3,.81,5.91,5.91,0,0,0-1.78,2A10,10,0,0,0,264.44,50Zm41.33,6.83c4.78-.59,13.13,4.65,14.35,5.44l-.18,0C315.12,60,306.59,59.46,302.81,60,302.81,60,302.34,57.24,305.77,56.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.17,49.94c0,6.07,3.69,15.27,8.25,17.91s8.24-2.32,8.24-8.38S337,46.33,332.42,43.7,324.17,43.85,324.17,49.94Zm14.19,8.19a11,11,0,0,1-.32,2.6c-.4-3.89-2.76-8.06-5.62-9.71s-5.24-.22-5.62,3.25a15.18,15.18,0,0,1-.33-3c0-4.38,2.66-6.4,5.95-4.5S338.36,53.75,338.36,58.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.4 54.84 329.81 57.38 332.43 63.27 335.03 60.37 332.4 54.84",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.35,59.51l.82,1.73.11-4.73-1,1A1.92,1.92,0,0,0,331.35,59.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-3"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175,344l3.43-2s-2-.63-2.88-.21S175,344,175,344Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,341.84a4.16,4.16,0,0,1,6.12,0c3.33,3.06,3.5,6.1,4.89,6.05S185,323.43,185,323.43l-13.15,12.23Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.63,341.84a4.16,4.16,0,0,1,6.12,0c3.33,3.06,3.5,6.1,4.89,6.05S185,323.43,185,323.43l-13.15,12.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,256.77l.21-.13-8-4.93-82.78-47.86-140.2,81C83.37,286.16,83,288,84.7,289l3.09,1.77,84.82,49,.61-.44Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.33,256.77l.21-.13-8-4.93-82.78-47.86-140.2,81C83.37,286.16,83,288,84.7,289l3.09,1.77,84.82,49,.61-.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93,311.87l-6.56-1.36v26.31c4,1.68,6.48,3.27,6.89,6.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46,337.17l-84-48.52a5.83,5.83,0,0,1-2.64-4.57V258.15l84.84,49.41s1,3.67,4,4.82.72,2.33.72,2.33v22.11C174.77,336.51,174.46,337.17,174.46,337.17Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21,311c-.87-.5-1.56-.54-1.56-.06v.82c0,.91-1.38.87-3.11-.12s-3.11-2.53-3.11-3.44v-.83c0-.47-1.17-1.52-2.62-2.36l136.72-78.34,2.12,1.23a2,2,0,0,1,.52,1.14v.82c0,.91,1.39,2.45,3.09,3.44s3.11,1,3.11.12v-.82c0-.47.69-.44,1.56.06Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.21,311c-.87-.5-1.56-.54-1.56-.06v.82c0,.91-1.38.87-3.11-.12s-3.11-2.53-3.11-3.44v-.83c0-.47-1.17-1.52-2.62-2.36l136.72-78.34,2.12,1.23a2,2,0,0,1,.52,1.14v.82c0,.91,1.39,2.45,3.09,3.44s3.11,1,3.11.12v-.82c0-.47.69-.44,1.56.06Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,228l.22-.13-2.11-1.22-90.75-52.39L85.56,250.62c-2.19,1.26-2.57,3.08-.86,4.06l3.09,1.78,84.84,51.1Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.43,228l.22-.13-2.11-1.22-90.75-52.39L85.56,250.62c-2.19,1.26-2.57,3.08-.86,4.06l3.09,1.78,84.84,51.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,231.77,180.79,310.64l4.78,3.74,136.17-78.62a5.34,5.34,0,0,0-1.82-2.54Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.4,231.77,180.79,310.64l4.78,3.74,136.17-78.62a5.34,5.34,0,0,0-1.82-2.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.21,271.09a1.88,1.88,0,0,0,.24-.18.52.52,0,0,0,.16-.14,2,2,0,0,0,.27-.36,1,1,0,0,0,.14-.2,4.41,4.41,0,0,0,.35-.76,7.71,7.71,0,0,0,.27-.89c.08-.33.14-.67.2-1a4.17,4.17,0,0,0,.08-.63c0-.17,0-.32,0-.5,0-.38.05-.78.05-1.19V242.64a18.59,18.59,0,0,0-1.27-6.88L185.57,314.38,185,349.74l136.16-78.63Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.66,310.49l1.53-1.26c.83-.67.89-1.05.89-2.47V289.09c0-1.19,0-1.57-.92-1.27l-1.5.48V286l9.48-5.47v2.33l-1.87,1.42a2.21,2.21,0,0,0-1,2.23v19.74l2.5-1.44c2.44-1.41,3.39-3.33,4.45-8.57l2.18-1.26-.8,9.14-15,8.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.65,300.68l1.35-1.05c.69-.58.89-1.2,1.26-2.83l6-25.56,3.68-2.12,5.91,18.82c.32,1,.46,1.53,1.23,1.27l1.15-.39v2.29l-8.87,5.12v-2.29l1.32-1c.78-.6.84-1.13.55-2.23l-.89-3.24-6.37,3.68-.89,4.11c-.32,1.41-.17,1.9.66,1.65l1.26-.42v2.29L259.65,303Zm12.09-15.51-2.44-8.88-.12.07-2.64,11.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.54,268.61c-.26-1.22-.46-1.49-1.29-1.16l-1.15.43v-2.33l8.93-5.16v2.22l-1.46,1.08c-.78.56-.89,1-.67,2.25l2.76,15.55.12-.07L292,257.53l4.34-2.51,4.42,19,.11-.07,3-18.71c.23-1.47.11-1.86-.69-1.63l-1.41.47v-2.18l7.41-4.27v2.22l-1.35,1c-.69.51-1.06,1.15-1.35,2.85l-4.16,24.66-5,2.89-4.07-17.77-.09,0-3.9,22.37-4.74,2.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,303.47,220.89,294c2.5,12.56,2.86,24.36,0,35l-16.42,9.48C207.33,327.83,207,316,204.47,303.47Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.47,303.47,220.89,294c2.5,12.56,2.86,24.36,0,35l-16.42,9.48C207.33,327.83,207,316,204.47,303.47Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,290.48l6.12-3.54c2.5,12.56,2.86,24.37,0,35L227,325.51C229.83,314.84,229.47,303,227,290.48Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,290.48l6.12-3.54c2.5,12.56,2.86,24.37,0,35L227,325.51C229.83,314.84,229.47,303,227,290.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.83,321.27h-3a13.82,13.82,0,0,0-1.48-6.66,4,4,0,0,1-2.5.82,8,8,0,0,1-3.8-1.19,11.67,11.67,0,0,1-3.52-3.09c-.06-.09-.13-.18-.18-.27a5,5,0,0,1-.91-2.61L90.91,261.8l-2.72-1.58-3.49-2a1.86,1.86,0,0,1-1.07-1.57v-3.57a1.89,1.89,0,0,0,1.07,1.62l0,0L94,260,171.81,305c1.44.84,2.63,1.89,2.63,2.36v.82a2.48,2.48,0,0,0,.72,1.45,8.91,8.91,0,0,0,2.38,2c1.72,1,3.11,1,3.11.12v-.82c0-.48.68-.45,1.55.06l1.54.9C185.45,312.84,186.83,317.06,186.83,321.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.83,321.27h-3a13.82,13.82,0,0,0-1.48-6.66,4,4,0,0,1-2.5.82,8,8,0,0,1-3.8-1.19,11.67,11.67,0,0,1-3.52-3.09c-.06-.09-.13-.18-.18-.27a5,5,0,0,1-.91-2.61L90.91,261.8l-2.72-1.58-3.49-2a1.86,1.86,0,0,1-1.07-1.57v-3.57a1.89,1.89,0,0,0,1.07,1.62l0,0L94,260,171.81,305c1.44.84,2.63,1.89,2.63,2.36v.82a2.48,2.48,0,0,0,.72,1.45,8.91,8.91,0,0,0,2.38,2c1.72,1,3.11,1,3.11.12v-.82c0-.48.68-.45,1.55.06l1.54.9C185.45,312.84,186.83,317.06,186.83,321.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.79,321.27v22.57c0,.32,0,.64,0,.94l-.07.77a.1.1,0,0,1,0,.07c-.27-2.42-2.59-4.58-4.6-5.73a7.72,7.72,0,0,0-3.72-1.16,4.1,4.1,0,0,0-2.73,1l-.27-.15-.53-.32L94,294.32l-4.47-2.57L88.23,291c-1.31-.76-2.64-1.52-3.76-2.18a1.78,1.78,0,0,1-.84-1.46v3.57a1.71,1.71,0,0,0,.78,1.37l0,0c.44.26.91.52,1.38.81l.87.5c.52.29,1,.59,1.5.87.33.19.64.38.93.53l.65.38,1.14.67,61.83,35.68,19.74,11.4c1.4.82,2.54,1.11,2.62.68a1,1,0,0,0,0-.14v-.8c0-1,1.39-1,3.1,0s2.41,2.15,2.44,3.11v1a1.41,1.41,0,0,0,.45,1.16c.12.08.29.17.46.26s.61.35,1,.56l1.2.71a1.23,1.23,0,0,0,1.54-.14.4.4,0,0,0,.15-.14,1.93,1.93,0,0,0,.28-.36v0a.75.75,0,0,0,.13-.18,3.77,3.77,0,0,0,.35-.76,7.72,7.72,0,0,0,.28-.89c.07-.33.13-.67.2-1a4.34,4.34,0,0,0,.07-.63c0-.17,0-.32,0-.5,0-.38,0-.78,0-1.19V321.27Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.79,321.27v22.57c0,.32,0,.64,0,.94l-.07.77a.1.1,0,0,1,0,.07c-.27-2.42-2.59-4.58-4.6-5.73a7.72,7.72,0,0,0-3.72-1.16,4.1,4.1,0,0,0-2.73,1l-.27-.15-.53-.32L94,294.32l-4.47-2.57L88.23,291c-1.31-.76-2.64-1.52-3.76-2.18a1.78,1.78,0,0,1-.84-1.46v3.57a1.71,1.71,0,0,0,.78,1.37l0,0c.44.26.91.52,1.38.81l.87.5c.52.29,1,.59,1.5.87.33.19.64.38.93.53l.65.38,1.14.67,61.83,35.68,19.74,11.4c1.4.82,2.54,1.11,2.62.68a1,1,0,0,0,0-.14v-.8c0-1,1.39-1,3.1,0s2.41,2.15,2.44,3.11v1a1.41,1.41,0,0,0,.45,1.16c.12.08.29.17.46.26s.61.35,1,.56l1.2.71a1.23,1.23,0,0,0,1.54-.14.4.4,0,0,0,.15-.14,1.93,1.93,0,0,0,.28-.36v0a.75.75,0,0,0,.13-.18,3.77,3.77,0,0,0,.35-.76,7.72,7.72,0,0,0,.28-.89c.07-.33.13-.67.2-1a4.34,4.34,0,0,0,.07-.63c0-.17,0-.32,0-.5,0-.38,0-.78,0-1.19V321.27Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-3"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.35,298.8l3.17-1.82a5.13,5.13,0,0,0-2.66-.18C173,297.19,173.35,298.8,173.35,298.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,296.81a3.83,3.83,0,0,1,5.64,0c3.08,2.83,3.24,5.63,4.51,5.58s1.26-22.57,1.26-22.57l-12.14,11.29Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.18,296.81a3.83,3.83,0,0,1,5.64,0c3.08,2.83,3.24,5.63,4.51,5.58s1.26-22.57,1.26-22.57l-12.14,11.29Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,218.31l.2-.11-7.39-4.55L220.2,169.48,90.83,244.27c-2,1.17-2.37,2.85-.8,3.75l2.86,1.64,78.27,45.21.56-.4Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.77,218.31l.2-.11-7.39-4.55L220.2,169.48,90.83,244.27c-2,1.17-2.37,2.85-.8,3.75l2.86,1.64,78.27,45.21.56-.4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.61,278.84l-6.06-1.25v14.59c3.65,1.55,6,3,6.36,6.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86,292.5,95.32,247.73a5.39,5.39,0,0,1-2.43-4.22V229.27l78.29,45.59s.93,3.39,3.71,4.45.66,2.15.66,2.15v10.72C173.15,291.9,172.86,292.5,172.86,292.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,278c-.8-.47-1.43-.5-1.43-.06v.76c0,.84-1.28.8-2.87-.11s-2.87-2.33-2.87-3.18v-.76c0-.44-1.08-1.41-2.42-2.18L296.58,200.2l1.95,1.13a1.8,1.8,0,0,1,.48,1v.75c0,.85,1.28,2.27,2.86,3.18s2.87,1,2.87.12v-.76c0-.44.63-.41,1.43.05Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,278c-.8-.47-1.43-.5-1.43-.06v.76c0,.84-1.28.8-2.87-.11s-2.87-2.33-2.87-3.18v-.76c0-.44-1.08-1.41-2.42-2.18L296.58,200.2l1.95,1.13a1.8,1.8,0,0,1,.48,1v.75c0,.85,1.28,2.27,2.86,3.18s2.87,1,2.87.12v-.76c0-.44.63-.41,1.43.05Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,201.45l.2-.12-1.95-1.13-83.73-48.34-122,70.46c-2,1.17-2.37,2.84-.8,3.75l2.86,1.64,78.29,47.15Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.33,201.45l.2-.12-1.95-1.13-83.73-48.34-122,70.46c-2,1.17-2.37,2.84-.8,3.75l2.86,1.64,78.29,47.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.76,204.93,178.7,277.71l4.42,3.45,125.65-72.55a4.93,4.93,0,0,0-1.68-2.34Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.76,204.93,178.7,277.71l4.42,3.45,125.65-72.55a4.93,4.93,0,0,0-1.68-2.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.27,231.52a.87.87,0,0,0,.23-.16.35.35,0,0,0,.14-.13,1.4,1.4,0,0,0,.26-.33,1.22,1.22,0,0,0,.12-.19,3.19,3.19,0,0,0,.32-.7,6.4,6.4,0,0,0,.26-.81c.07-.31.12-.62.18-1a3.54,3.54,0,0,0,.07-.58c0-.15,0-.29,0-.46,0-.35.05-.72.05-1.1V215a17.16,17.16,0,0,0-1.17-6.35L183.12,281.16l-.53,22.94,125.64-72.55Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.27,231.52a.87.87,0,0,0,.23-.16.35.35,0,0,0,.14-.13,1.4,1.4,0,0,0,.26-.33,1.22,1.22,0,0,0,.12-.19,3.19,3.19,0,0,0,.32-.7,6.4,6.4,0,0,0,.26-.81c.07-.31.12-.62.18-1a3.54,3.54,0,0,0,.07-.58c0-.15,0-.29,0-.46,0-.35.05-.72.05-1.1V215a17.16,17.16,0,0,0-1.17-6.35L183.12,281.16l-.53,22.94,125.64-72.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M193.53,275.14l15.15-8.74c2.3,11.59,2.63,12.8,0,22.64l-15.15,8.75C196.17,287.94,195.83,286.73,193.53,275.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.91,226.43l15.15-8.75c2.3,11.59,2.63,12.8,0,22.64l-15.15,8.75C280.55,239.23,280.21,238,277.91,226.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,287.51h-2.81a12.84,12.84,0,0,0-1.36-6.14,3.79,3.79,0,0,1-2.31.76,7.31,7.31,0,0,1-3.5-1.1,10.59,10.59,0,0,1-3.25-2.86,1.38,1.38,0,0,1-.17-.25,4.47,4.47,0,0,1-.84-2.4L95.77,232.64l-2.52-1.46L90,229.32a1.7,1.7,0,0,1-1-1.45v-3.29a1.73,1.73,0,0,0,1,1.49l0,0L98.6,231l71.82,41.47c1.33.77,2.43,1.74,2.43,2.18v.76a2.32,2.32,0,0,0,.66,1.33,8.15,8.15,0,0,0,2.19,1.85c1.59.91,2.87.95,2.87.11V278c0-.44.63-.41,1.44.06l1.42.83C183,279.74,184.28,283.63,184.28,287.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,287.51h-2.81a12.84,12.84,0,0,0-1.36-6.14,3.79,3.79,0,0,1-2.31.76,7.31,7.31,0,0,1-3.5-1.1,10.59,10.59,0,0,1-3.25-2.86,1.38,1.38,0,0,1-.17-.25,4.47,4.47,0,0,1-.84-2.4L95.77,232.64l-2.52-1.46L90,229.32a1.7,1.7,0,0,1-1-1.45v-3.29a1.73,1.73,0,0,0,1,1.49l0,0L98.6,231l71.82,41.47c1.33.77,2.43,1.74,2.43,2.18v.76a2.32,2.32,0,0,0,.66,1.33,8.15,8.15,0,0,0,2.19,1.85c1.59.91,2.87.95,2.87.11V278c0-.44.63-.41,1.44.06l1.42.83C183,279.74,184.28,283.63,184.28,287.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,287.51v11.15c0,.29,0,.59,0,.87l-.07.7a.17.17,0,0,1,0,.07c-.26-2.23-2.39-4.23-4.25-5.29a7.1,7.1,0,0,0-3.43-1.07,3.8,3.8,0,0,0-2.52.93l-.25-.14-.49-.29L98.6,253l-4.12-2.38c-.38-.22-.79-.45-1.18-.69l-3.48-2a1.67,1.67,0,0,1-.77-1.35v3.29a1.6,1.6,0,0,0,.72,1.27s0,0,0,0c.4.24.84.48,1.27.75l.81.46,1.38.8c.3.19.59.36.85.5s.42.25.61.35l1,.62,57.05,32.92L171,298c1.3.76,2.35,1,2.42.63a.45.45,0,0,0,0-.14v-.73c0-.92,1.28-.92,2.85,0s2.22,2,2.25,2.87v.9a1.35,1.35,0,0,0,.42,1.07l.43.23.9.52c.33.2.71.43,1.11.65a1.13,1.13,0,0,0,1.42-.13.31.31,0,0,0,.14-.12,1.42,1.42,0,0,0,.25-.34h0a1.09,1.09,0,0,0,.13-.17,3.73,3.73,0,0,0,.32-.7,7.1,7.1,0,0,0,.25-.82c.07-.31.13-.62.19-1a5.22,5.22,0,0,0,.07-.57c0-.16,0-.3,0-.47,0-.35,0-.71,0-1.09V287.51Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,287.51v11.15c0,.29,0,.59,0,.87l-.07.7a.17.17,0,0,1,0,.07c-.26-2.23-2.39-4.23-4.25-5.29a7.1,7.1,0,0,0-3.43-1.07,3.8,3.8,0,0,0-2.52.93l-.25-.14-.49-.29L98.6,253l-4.12-2.38c-.38-.22-.79-.45-1.18-.69l-3.48-2a1.67,1.67,0,0,1-.77-1.35v3.29a1.6,1.6,0,0,0,.72,1.27s0,0,0,0c.4.24.84.48,1.27.75l.81.46,1.38.8c.3.19.59.36.85.5s.42.25.61.35l1,.62,57.05,32.92L171,298c1.3.76,2.35,1,2.42.63a.45.45,0,0,0,0-.14v-.73c0-.92,1.28-.92,2.85,0s2.22,2,2.25,2.87v.9a1.35,1.35,0,0,0,.42,1.07l.43.23.9.52c.33.2.71.43,1.11.65a1.13,1.13,0,0,0,1.42-.13.31.31,0,0,0,.14-.12,1.42,1.42,0,0,0,.25-.34h0a1.09,1.09,0,0,0,.13-.17,3.73,3.73,0,0,0,.32-.7,7.1,7.1,0,0,0,.25-.82c.07-.31.13-.62.19-1a5.22,5.22,0,0,0,.07-.57c0-.16,0-.3,0-.47,0-.35,0-.71,0-1.09V287.51Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mullet--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M244.88,188.24c23,13.26,23,34.76,0,48s-60.21,13.26-83.18,0-23-34.76,0-48S221.91,175,244.88,188.24Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--base--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.55,177.72c20.84-12,54.64-12,75.48,0,10.43,6,15.6,13.9,15.59,21.79,0,2.44,0,5.72,0,8.16,0,7.89-5.16,15.77-15.59,21.79-20.84,12-54.64,12-75.48,0-10.43-6-15.6-13.9-15.58-21.79v-8.16C150,191.62,155.12,183.74,165.55,177.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.29,
    cy: 199.51,
    rx: 53.38,
    ry: 30.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53,172.73c15.88-9.17,41.64-9.17,57.52,0,7.95,4.58,11.89,10.59,11.88,16.6,0,1.86,0,3.55,0,5.41,0,6-3.93,12-11.88,16.61-15.88,9.17-41.64,9.17-57.52,0-7.95-4.59-11.89-10.6-11.88-16.61,0-1.86,0-3.55,0-5.41C162.64,183.32,166.58,177.31,174.53,172.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 203.29,
    cy: 189.33,
    rx: 40.68,
    ry: 23.48,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--mullet--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mallet--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.33,122.08c9-5.19,16.65-3.13,19.68,4.27.58,1.41,2.81,6.8,3.34,8.13a16.67,16.67,0,0,1,1.09,6.29c0,10.81-7.59,23.95-16.95,29.36a16.82,16.82,0,0,1-6,2.2l-8.65,1.16c-7.94,1.1-13.58-4.51-13.58-14.9C143.25,145.14,152.69,128.8,164.33,122.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.49,131c9.36-5.41,16.95-1,16.95,9.79s-7.59,23.95-16.95,29.36-17,1-17-9.79S162.13,136.38,171.49,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.82,132.4c-3.3-1.88-7.83-1.61-12.85,1.29-10.07,5.81-18.24,19.95-18.24,31.59,0,5.81,2.05,9.88,5.35,11.78,1.1.63,30.54,17.83,31.64,18.47,3.3,1.91,7.85,1.65,12.89-1.26,10.07-5.81,18.23-20,18.23-31.59,0-5.81-2-9.89-5.35-11.78Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.82,132.4c-3.3-1.88-7.83-1.61-12.85,1.29-10.07,5.81-18.24,19.95-18.24,31.59,0,5.81,2.05,9.88,5.35,11.78,1.1.63,30.54,17.83,31.64,18.47,3.3,1.91,7.85,1.65,12.89-1.26,10.07-5.81,18.23-20,18.23-31.59,0-5.81-2-9.89-5.35-11.78Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.59,186.34l-56.48-32.8a33.23,33.23,0,0,0-2.38,11.74c0,5.81,2.05,9.88,5.35,11.78,1.1.63,30.54,17.83,31.64,18.47,3.3,1.91,7.85,1.65,12.89-1.26A33.34,33.34,0,0,0,220.59,186.34Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,152.14c10.08-5.81,18.24-1.1,18.24,10.53s-8.16,25.78-18.24,31.59-18.24,1.11-18.24-10.53S201.53,158,211.6,152.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.06,186.62c0-10.81,7.59-24,16.95-29.36a16.47,16.47,0,0,1,6.42-2.25l8.75-1c7.8-.95,13.33,4.65,13.33,14.94,0,13.44-9.44,29.79-21.08,36.51-8.87,5.12-16.46,3.17-19.57-4-.63-1.44-3-6.9-3.56-8.21A16.37,16.37,0,0,1,200.06,186.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43,156.78c11.64-6.73,21.08-1.28,21.08,12.17s-9.44,29.79-21.08,36.51-21.08,1.27-21.08-12.17S212.79,163.5,224.43,156.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,169a40.92,40.92,0,0,1-4.42,18.17,48.06,48.06,0,0,1-11.35,15,31.4,31.4,0,0,1-8,5.07,16.22,16.22,0,0,1-2.25.79l-1.15.32c-.39.08-.79.12-1.19.19a12.61,12.61,0,0,1-4.78-.15,11.18,11.18,0,0,1-4.3-2.12c-.3-.26-.57-.56-.86-.83l-.43-.43-.35-.48-.71-1-.56-1.06a19.19,19.19,0,0,1-1.8-9.18l.17,2.34.37,2.31c.22.75.39,1.51.65,2.24l.44,1.07c.08.18.14.36.23.53l.29.51.57,1,.71.91.35.46.42.39c.28.26.55.54.84.78a10.47,10.47,0,0,0,4.1,1.9,15.42,15.42,0,0,0,9-1.22,30.67,30.67,0,0,0,7.76-5A50,50,0,0,0,244,178.17,37.37,37.37,0,0,0,245.51,169Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183,179.37a9.13,9.13,0,0,0-5.69-6,2.91,2.91,0,0,0-2.91.39h0l-16.62,15.74h0a2.91,2.91,0,0,0-.54,2.88,9.13,9.13,0,0,0,5.69,6,2.94,2.94,0,0,0,2.92-.4h0l16.62-15.74h0A2.92,2.92,0,0,0,183,179.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.42,182.27a2.92,2.92,0,0,0,.56-2.9,8,8,0,0,0-1.41-2.84l-21.44,20.33a8.08,8.08,0,0,0,2.75,1.55,2.94,2.94,0,0,0,2.92-.4l16.62-15.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17,228.82h0l43.75-38.56h0l0,0h0a3.81,3.81,0,0,1,3.74-.48,11.9,11.9,0,0,1,7.41,7.81,3.8,3.8,0,0,1-.73,3.77l-40.56,42.05,0,0a9.88,9.88,0,0,1-4.58,2.56,10,10,0,0,1-9.07-17.09Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,229a4.85,4.85,0,0,0,4.74,7.95,4.9,4.9,0,0,0,2-1h0L163,192.47a11.18,11.18,0,0,1,3.09,5.08,3.8,3.8,0,0,1-.73,3.77l-40.56,42.05h0A10,10,0,1,1,111,229Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.24,183.54a1.58,1.58,0,0,1,1.75.76c.23-.19.37-.51.65-.6s.69.19.91.47a6.72,6.72,0,0,1,.11,7.91,1.22,1.22,0,0,1-.38.37,1.18,1.18,0,0,1-.59.08,13.32,13.32,0,0,1-3.14-.47,3.42,3.42,0,0,1-2.51-1.77,4,4,0,0,1,.07-2.27,5.94,5.94,0,0,1,1.25-2.73C369.83,184.76,370.57,183.71,371.24,183.54Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.44,162.76c-8.18-9.79-8.19-11.87-5.78-17.56,1.32-3.11,7.9-13.59,15.14-24.18,8-11.67,12.21-13.32,17.46-14.59l-.61,23.18-13,21.66s9.47,16,11.32,20.63c2.66,6.58,1.73,15.18-3.49,19.56s-6.49,4.95-10.73,4.1-5.34-1.25-5.74-2.66c-1-3.52-1.57-4,.57-6,1.22-1.17,2.25-2.33,2.91-2.84a.62.62,0,0,1,.91.19c1.19,2-1.58,4.95-1.58,4.95a17,17,0,0,1,4.18,1.35c.53-3.73-.35-5.84.37-7.78.46-1.24,1.31-3.33.46-4.35C372.05,176.23,366.53,168.86,361.44,162.76Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.67,151.27c-2.81,2.61-7.14,2.72-9.25,2.26a9.57,9.57,0,0,0,9.95-1.12",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.66,104.65c-6.57,1.62-10.48,2.67-16.92,12.31-3.43,5.14-16.73,25.63-18.11,29.68s-1.07,6.33,3.07,11.73c4.35,5.68,7.22,8.94,7.22,8.94s3.57-3.94,15.4-6.24l-5.24-9.66,14.58-18.77Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.08,151.41c-1.59,2.48-8.22,3.21-11,2.7,3.62,2.51,9.72,1.37,11.75-1.27Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "394.37 341.66 388.64 339.94 390.29 336.18 393.91 339.08 394.37 341.66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.66,331.57s.41,3.51.52,4.62-4.62,4.84-5.81,5.47l-.46-2.58a20.29,20.29,0,0,0-2.6,4.37c-.86,1.63-1.91,4.69-4.4,6.88-3.7,3.25-9.63,5.12-15.76,5.68s-9.71-.69-11.52-1.88-2.44-2.65-2.09-4.17S399.66,331.57,399.66,331.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,320.47l-.18-2c-1.13,0-1.11,3-2.62,5.69a53.4,53.4,0,0,1-8.08,11.12c-5.94,5.81-11.31,9.55-14,12.17-3.54,3.5,3.26,8.36,13.25,7.26,5-.55,13.65-3.45,16-6.42s3.62-7.47,5.5-9.63,6-4.48,7.14-7.05c.61-1.41.39-3.33.12-7.14-.18-2.52,0-6.61-1.41-6.22l0,1.29c-.54,1.13-3.22,3.18-7.19,4.05C389.15,324,383.19,324.5,382.62,320.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.92,323.83c-1.92-.05-4-.54-4.9-2.16l0-.05a4.59,4.59,0,0,1-1.09,4c-1.68,2.12-12.25,17-12.25,17s9.91-12.33,11.82-14.66c2.81-3.43,3.74-3.87,6.46-4.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.62,327.75a.6.6,0,0,0,.7.48.59.59,0,0,0,.51-.68.61.61,0,0,0-1.21.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,331.06a.61.61,0,0,0,.7.49.59.59,0,1,0-.7-.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,334.38a.61.61,0,0,0,1.21-.2.61.61,0,0,0-1.21.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.25,337.69a.61.61,0,1,0,.51-.68A.6.6,0,0,0,377.25,337.69Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.46,341a.61.61,0,0,0,1.21-.2.6.6,0,0,0-.7-.48A.59.59,0,0,0,374.46,341Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.26,327.88a.21.21,0,0,0,.15-.07.24.24,0,0,0,0-.34,10.24,10.24,0,0,0-7.06-2.25h0a.24.24,0,1,0,.06.47,9.83,9.83,0,0,1,6.68,2.14A.24.24,0,0,0,386.26,327.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.47,331.19a.31.31,0,0,0,.15-.08.24.24,0,0,0,0-.34,10.24,10.24,0,0,0-7.06-2.25h0a.24.24,0,0,0-.21.27.23.23,0,0,0,.27.2,10,10,0,0,1,6.68,2.14A.25.25,0,0,0,383.47,331.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,334.51a.25.25,0,0,0,.15-.08.23.23,0,0,0,0-.33,10.19,10.19,0,0,0-7.06-2.25h0a.23.23,0,0,0-.21.26.25.25,0,0,0,.27.21,9.86,9.86,0,0,1,6.68,2.14A.29.29,0,0,0,380.68,334.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.89,337.83a.31.31,0,0,0,.15-.08.24.24,0,0,0,0-.34,10.24,10.24,0,0,0-7.06-2.25h0a.24.24,0,0,0-.21.26.24.24,0,0,0,.27.21,9.86,9.86,0,0,1,6.68,2.14A.3.3,0,0,0,377.89,337.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.1,341.14a.31.31,0,0,0,.15-.08.24.24,0,0,0,0-.34,10.24,10.24,0,0,0-7.06-2.25h0a.24.24,0,0,0-.21.27.24.24,0,0,0,.27.21,9.93,9.93,0,0,1,6.68,2.13A.25.25,0,0,0,375.1,341.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.08,358.83c.4,4.68,1.23,7.77,3,10.48s5.42,3.36,8.2,3.07a11.56,11.56,0,0,0,9.89-7.73c1.2-3.09.95-6.78.09-11.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,324.54c1.36.08,1.92,6.36,2.86,12.65,1,6.73,3.24,10.47,4,15,1.12,6.29.74,9.13-1.47,13s-12.08,7.89-16.22,2.49c-3.38-4.41-3.64-9.36-3.5-15.68a153.31,153.31,0,0,0-.09-16.07c-.38-4.73-.84-9.31.33-9.86.11.69.22,1.57.33,2.25s.29,3.09,1,3.1a9.75,9.75,0,0,0,0-1.79,2,2,0,0,1,.33-1.53,2.61,2.61,0,0,1,1.49-.68c1.33-.27,2.67-.53,4-.67.68-.07,1.35-.11,2-.12a23.43,23.43,0,0,1,3.56.08,1.16,1.16,0,0,1,.75.63,1.74,1.74,0,0,1,.09.72,4.7,4.7,0,0,0,.21,1.29c0,.19.19.41.38.37s.22-.23.21-.39c0-.76-.12-1.32-.18-2.2,0-.41-.11-1-.13-1.38S444.22,325,444.18,324.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.15,353.85a.46.46,0,0,1-.41.51.47.47,0,0,1-.53-.4.46.46,0,0,1,.41-.51A.47.47,0,0,1,446.15,353.85Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.59,349.49a.46.46,0,0,1-.41.51.47.47,0,0,1-.53-.4.45.45,0,0,1,.41-.51A.47.47,0,0,1,445.59,349.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.06,345.38a.46.46,0,0,1-.41.51.47.47,0,0,1-.53-.4.45.45,0,0,1,.41-.51A.48.48,0,0,1,445.06,345.38Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.53,341.33a.45.45,0,0,1-.41.51.47.47,0,0,1-.53-.4.46.46,0,0,1,.41-.51A.47.47,0,0,1,444.53,341.33Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.81,342.17a.46.46,0,0,1-.41.51.47.47,0,0,1-.53-.4.45.45,0,0,1,.41-.51A.47.47,0,0,1,433.81,342.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.34,346.25a.47.47,0,0,1-.94.11.45.45,0,0,1,.41-.51A.48.48,0,0,1,434.34,346.25Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,350.36a.46.46,0,0,1-.41.51.47.47,0,0,1-.53-.4.45.45,0,0,1,.41-.51A.47.47,0,0,1,434.87,350.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.43,354.72a.45.45,0,0,1-.41.51.47.47,0,0,1-.53-.4.46.46,0,0,1,.41-.51A.47.47,0,0,1,435.43,354.72Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.48 356.71 435.07 326.32 436.82 326.26 439.48 356.71",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.71,354.13h-.07c-3.16-.61-8.5-.21-10.57.82a.26.26,0,0,1-.33-.1.23.23,0,0,1,.11-.31c2.19-1.09,7.58-1.51,10.88-.86a.23.23,0,0,1,.19.27A.23.23,0,0,1,445.71,354.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.15,349.78a.27.27,0,0,1-.13,0c-2.42-1.05-8.15-.34-10.52.84a.24.24,0,0,1-.32-.11.23.23,0,0,1,.1-.31c2.47-1.22,8.38-1.95,10.94-.84a.23.23,0,0,1,.12.3A.25.25,0,0,1,445.15,349.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.61,345.67a.25.25,0,0,1-.12,0c-2.42-1-8.15-.34-10.52.84a.24.24,0,0,1-.32-.1.23.23,0,0,1,.1-.32c2.47-1.22,8.38-1.95,10.93-.84a.22.22,0,0,1,.13.3A.26.26,0,0,1,444.61,345.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.09,341.62l-.13,0c-2.42-1.05-8.14-.34-10.51.83a.25.25,0,0,1-.33-.1.23.23,0,0,1,.11-.31c2.46-1.22,8.38-1.95,10.93-.85a.24.24,0,0,1-.07.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.53,168.66c3.27,38.41,3.91,95,3.91,95,.29,2.92,2.95,8.76,3.38,23.22.53,17.64-1.24,42.59-1.24,42.59s-9,4.87-17.94,2c0,0-9.45-34.27-12.84-56.45-2.65-17.27-7.21-49.55-7.21-49.55l-2.51,32.61s.66,11,.34,18.61c-.36,8.92-6.37,45.15-6.37,45.15s-10.44,5.18-20.05.32c0,0-2.76-52.72-3.06-63.44-.58-21,.1-62.47.81-89.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35,317s2.55,2,8.35,2.46S401.3,317,401.3,317l-.93,5.86a24,24,0,0,1-12.59,2.28c-7.11-.69-8.2-2.2-8.2-2.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.14,324.68a28.18,28.18,0,0,1-10,2.77,24.64,24.64,0,0,1-10-1.19l.93,5.86s3.06,2.08,10.17,1.39,8.75-2.89,8.75-2.89Z",
    style: {
      fill: "#455a64"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M423.89,216.44q.53,12.36,1.33,24.73.39,6.18.84,12.36l.45,6.18.23,3.09c.07,1,.26,2.05.38,3.08,1.09,8.21,2.63,23.09,3.87,31.29s2.57,16.39,4.05,24.57q-1.14-12.35-2.64-24.67c-1-8.21-2.43-23.09-3.57-31.29-.13-1-.32-2-.4-3.08l-.25-3.09-.54-6.17q-.54-6.16-1.14-12.33Q425.33,228.77,423.89,216.44Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.81,217.48c-1.09,7.29-1.71,14.62-2.19,22s-.93,14.7-.69,22.05.2,19.67.44,27,.55,14.71,1,22.06q.35-11,.36-22c0-7.35,0-19.67-.05-27l-.1-5.52,0-1.37,0-1.37.07-2.75.31-11,.36-11C385.43,224.82,385.62,221.15,385.81,217.48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M408.59,225.54l-4-21s-10.82-1.48-16.39-6.25c0,0,3.6,6.33,13.82,8.77L406,225.61l.1,32.54Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.82,107.32s7.07,5.19,4.47,18.81A192.9,192.9,0,0,0,440.21,153c-.17,7.13,1.55,28.29,1.55,28.29-10.45,13.33-58.25,11.44-64.52,0,0,0,.85-48.08,3-58.67,1.88-9.24,6-15.26,9.42-18l13.89-3.37,15.36.3Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.9,63.8c-1.64-4.12-5-4.44-5-4.44-1-4.39-7.49-9.52-16.35-8.42s-13.2,3.83-16,9.21-.42,9.13-.42,9.13l25.94-1.67a24.09,24.09,0,0,0,.31,3.7c.62,3.93,4.44,8.55,4.44,8.55l0,5.53.27,7.91a5.09,5.09,0,0,0,2.81-2.53c.86-1.9,1.72-4.81,3-11.57S428.11,66.83,426.9,63.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.77,87.11c-2.81,2-5.6-.79-5.6-.79l.29,15.44s0,4-4.9,7.11c-6.87,4.34-9.85,6.61-12.65,11-2.71-6.89-6.78-11.57-2.55-17.17L401.29,99a34.26,34.26,0,0,1-3.83-.18c-3.66-.36-6.11-3.1-7.42-7-2.12-6.21-2.43-17.25.19-28.65,4.58-3.92,16.45-4.11,25.3.79,0,7.24,2.2,10.33,2.34,13a7.19,7.19,0,0,0,1.68,1.94c1.4,1.07,2.3-2,3.35-3.21s4.6-3,6.63.71S429.21,85.35,426.77,87.11Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.16,70.61,410,72.7a2.28,2.28,0,0,0-.92-3A2.12,2.12,0,0,0,406.16,70.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,71.59l4.15-1.48a2.11,2.11,0,0,0-2.74-1.38A2.31,2.31,0,0,0,391.25,71.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,75a1.78,1.78,0,1,1-1.83-1.74A1.78,1.78,0,0,1,408.3,75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,74.83a1.78,1.78,0,1,1-1.83-1.74A1.63,1.63,0,0,1,395.73,74.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.33 72.05 400.55 83.45 394.44 81.6 401.33 72.05",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,74.71h0l-.08,0A.13.13,0,0,0,389.26,74.71Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.29 74.72 389.28 74.71 389.28 74.71 389.29 74.72",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.13,66.52a6.56,6.56,0,0,0-3.32,0,18.44,18.44,0,0,1-3.39.32c-2.08-.09-4.23-1.39-6.31-.74-.05,0-.07.12,0,.12a8,8,0,0,1,3.28.47,13,13,0,0,0,3.12.73,12.78,12.78,0,0,0,3.43-.35c.53-.11,1.05-.21,1.58-.29a9.61,9.61,0,0,0,1.61-.23S407.17,66.53,407.13,66.52Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.92,76.05c-.3,7.77-3,8.33-5.73,8.81-3.64.63-5.47-1.33-12-1.28-4,0-5.2,1.22-7.44,2.17-1.66.7-3.39.61-3.67-1a55.59,55.59,0,0,1-.56-10.06,73.76,73.76,0,0,0,0,14.11c.57,3.64,1.57,7.05,3.6,8.74,2.82,2.34,8.71,2.65,16,1s10-4.12,10.83-6.71c2.79-8.4,1.63-12.35,2.58-13.94S417.92,76.05,417.92,76.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.1,85.9c3.73-.11,5,.56,5.16,3.12.29,3.65.11,4.88-1.28,5.09-1.65.23-2.85.34-2.92-.69a4.06,4.06,0,0,1,.22-2.35c.57-.7.37-.8-1.27-.75s-1.61.34-1.12.84.33,1.62.34,2.34-.17,1.1-2.53.89c-2.06-.18-1.72-1.83-1.71-5C396,87.3,396.88,86,401.1,85.9Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.54,86.82l-5,.73a2.46,2.46,0,0,0,2.78,2.19A2.63,2.63,0,0,0,403.54,86.82Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.89,87.58a2.47,2.47,0,0,1,.61,0,2.58,2.58,0,0,1-2.14,2.11,2.38,2.38,0,0,1-.8,0A2.29,2.29,0,0,1,402.89,87.58Z",
    style: {
      fill: "#f28f8f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tie--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.87,116s-2.55-5-2.54-6.9l3.17-3.22.92,8.07Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.87,116s-2.55-5-2.54-6.9l3.17-3.22.92,8.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.18 114.28 410.57 110.67 415.01 113.71 406.76 117.85 405.18 114.28",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.18 114.28 410.57 110.67 415.01 113.71 406.76 117.85 405.18 114.28",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5,164c-2.71-15.3-3-39.27-2.68-43.47l-2.93-.3c-2.07,5-8.19,29.5-8.12,41.42-.18,4.15,5.11,15.33,7.91,15.45S407.94,166.48,407.5,164Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.5,164c-2.71-15.3-3-39.27-2.68-43.47l-2.93-.3c-2.07,5-8.19,29.5-8.12,41.42-.18,4.15,5.11,15.33,7.91,15.45S407.94,166.48,407.5,164Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,120.84c.1-.26.16-.44.24-.63h0l2.93.3h0a10.56,10.56,0,0,0,0,1.29A5.12,5.12,0,0,1,401.65,120.84Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26,113.87a12.56,12.56,0,0,0-2.77-.13,6.55,6.55,0,0,0-1.62,2.25,10.11,10.11,0,0,0,1,4.22,3.51,3.51,0,0,0,2.93.3,6.18,6.18,0,0,0,2.13-2.8A5.57,5.57,0,0,0,405.26,113.87Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.26,113.87a12.56,12.56,0,0,0-2.77-.13,6.55,6.55,0,0,0-1.62,2.25,10.11,10.11,0,0,0,1,4.22,3.51,3.51,0,0,0,2.93.3,6.18,6.18,0,0,0,2.13-2.8A5.57,5.57,0,0,0,405.26,113.87Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.79,103.83A73.21,73.21,0,0,1,417.7,124c-6.64,10.21-17.93,22.42-17.93,22.42s-6-22.21,0-44.18l-12.15,3s-8.41,6.56-9.49,23.58-.89,56.72-.89,56.72a38.43,38.43,0,0,0,16,8.68l2-10.05,3.11,11.44a48.28,48.28,0,0,0,26.71-1.39c14.69-5,18.4-10.66,18.4-10.66s-2.47-21.67-2-30.55,2.47-20.72,2.94-27.79-2.17-17-2.17-17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,113.86c.1,0,.22.22.31.24,2.05-1.1,2.37-1.47,2.91-1.32,1,.3,3.45,4.57,4.05,6s.49,1.36,2.38.11a33.83,33.83,0,0,0,8.55-8.24,25,25,0,0,0,3.39-6.78s-2.15-3-2.78-4.1c-1.21-2.2-1.4-3.36-2.65-3.17l-.1,2c-.22,1.91-2.62,3.49-5.3,5.79s-7,4.5-8,5.49A20.66,20.66,0,0,0,405.2,113.86Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.5,115.48c.3.78,2.78-5.32,4-5.19.59,0,1.91,1.7,3,3.45l.83,0a19,19,0,0,1-1.26-4.64c-.24-2.08.58-8.25.58-8.25l-.15-1.46c-.32,0-.66,0-1.07,0a8.43,8.43,0,0,0-1.06,1.43c-1.19,1.94-4.29,5.5-4.68,7.83A20.37,20.37,0,0,0,395.5,115.48Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.82,107.32c8.09,1.42,12.06,6.5,15.62,17,4.86,14.36,9.13,28.51,10.05,35.7L445.4,154.8l-10.21-20.56S430.59,117.6,438.82,107.32Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.98 195.84 441.28 189.49 447.56 136.54 406.26 142.89 399.98 195.84",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.98 195.84 441.28 189.49 447.56 136.54 406.26 142.89 399.98 195.84",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.51 193.51 441.08 187.42 446.94 138.04 407.37 144.13 401.51 193.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.59,178.56l4-33.34,37-8.7-6.29,53-39.14,9.19a1,1,0,0,1-1.25-1.16l2-16.88a1.9,1.9,0,0,1,1.36-1.55Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.22,160c0,5.43-.81,6.33-6.76,9.38s-21,7.75-32.89,8.9c-7.76.75-11.75.38-14.76-.81A12.45,12.45,0,0,1,402,163.85c-1.29-3.75.67-4.26,2.29-4.66l-.3,2.45s3.48,2.37,6.69,2.41.23-3.71-.35-6-.45-3.57,1.4-4.64c1.05,0,1.39,1.43,4.62,4.65,2.46,2.44,4.37,6.91,8.18,6.39,3-.41,20.7-8.62,20.7-8.62l.8-6.79Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.49,160c.23,3.38-.37,5.15-1.93,6.61s-8,4.49-12,5.87-14.32,4.18-16.31,4.55c2.06-3.22,1.56-9.56-.19-12.41s-4.05-2.15-4.05-2.15l15.25-6.86,1.1-9.29Z",
    style: {
      fill: "#e6e6e6"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "234.75 424.05 231.07 422.25 234.69 421.22 234.75 424.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.29,431s43.33-19.89,43.89-16.95a4.36,4.36,0,0,1,0,1.77l.12-.16-.78,5.5a12.93,12.93,0,0,1-6.75,2.87c0-.26,0-1.9-.06-2.83a22.6,22.6,0,0,0-3.82,2.06c-2.77,1.86-4.55,5.11-7.49,8.89-2.14,2.75-6,4.05-11.65,4.88-6.12.9-11.52-.26-13-1.9C197.47,433.84,198.07,431.41,198.29,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,430c.42-.44,2-2.16,4.05-4a79.64,79.64,0,0,1,6.24-5.4,23.86,23.86,0,0,0,3.1-2.6A32.72,32.72,0,0,0,215,415.4a47.65,47.65,0,0,0,5.2-9,20.74,20.74,0,0,0,1.81-4.71,29.37,29.37,0,0,0,.49-5.21c0-7.88-.15-9.13-.21-15.13l18.35.53c-.59,3.33-1.48,7.87-1.78,11.65-.46,5.75-.61,7,1.64,12.75.66,1.68,1.65,3.3,1.74,5.11.15,2.94-2.13,5.49-4.7,6.94-2.12,1.2-4.56,1.72-6.62,3a21.45,21.45,0,0,0-5.39,5.36c-1.45,1.89-2.61,4.12-4.66,5.45a19.11,19.11,0,0,1-7.06,2.49,38.08,38.08,0,0,1-9.5.52C199.82,434.85,196.45,433.22,199.48,430Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.39,420.94a8.1,8.1,0,0,0-6.73-.59c-3.2,2.56-5.84,4.84-7.7,6.43-2.27,1.93-4.25,3.7-4.15,5.9.14,3.45,13.48,4.43,20.92,1.13a9.31,9.31,0,0,0,5.25-4.66S222.86,424.32,216.39,420.94Zm25.3-12.52c-1.15-2.21-1.59-3.34-1.59-3.34-2.58,1.42-7.06,7.95-5,14.49a9.87,9.87,0,0,0,6.51-4.49A6.26,6.26,0,0,0,241.69,408.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,413.86c-1.23,2,.34,9.43,0,14.73-.26,4.81-1.57,13.21-.1,18,1.74,5.65,5.29,12.2,11.93,6.94,4.12-3.27,6.49-7.5,7.06-14.43.41-4.82-1.5-11.49-3.14-17.41-1.91-6.91-2.63-10.61-2.63-10.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.65,378.36c.45,11.24-.88,19.12-1,26.32a50.81,50.81,0,0,0,1,9.72c.94,4.6,2.52,11,3.19,14,.93,4.16,1.63,6.79.18,11.45a5.45,5.45,0,0,1-.47,1.05c-2,3.84-7.13,6.73-8.76,6.26a2.81,2.81,0,0,1-2.87,1,3.65,3.65,0,0,1-.55-.13,4.08,4.08,0,0,1-.54-.22,5.59,5.59,0,0,1-2.71-3.54,9.48,9.48,0,0,1-.26-1c-1.17-5.79-.3-9.53-.18-11.8.13-2.61,0-5.94-.23-10.15s-1.19-17.46-2.64-23.8c-1.07-4.42-2.41-10-3.83-15.87Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.84,433.78c-4-1.79-15.69-2.07-17.56,3.61-.07,5.35-.11,9,3.26,13.63,4.47,6.2,10.34-.34,12.6-4.5S292.38,436.66,291.84,433.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273,241c5.66,10.2,9.86,18.54,10.57,49s.66,38.93.79,42.6,2.3,10.21,4.26,28.27S288,405.4,288,405.4s-.91,2.66-7.82,3.31c-6.37.61-9-2-9-2s-9.31-39.66-11.78-50.53-9.66-46.62-9.66-46.62l-2.2,29.06a214.63,214.63,0,0,1-1.71,25.8c-1.87,15.85-5.74,36.39-5.74,36.39a17.8,17.8,0,0,1-9.65,3,16.5,16.5,0,0,1-8.6-2.2s-3.41-52.72-3.5-70.68-2.25-62.75,3.28-89.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.2,263.48c.73,2.91,1.38,5.84,2.08,8.77s1.37,5.86,2.11,8.81a60,60,0,0,0-.64-9.09c-.41-3-1-6-1.69-8.94a79,79,0,0,0-2.64-8.73,42.49,42.49,0,0,0-3.93-8.22c.92,2.9,1.74,5.78,2.52,8.68S265.51,260.56,266.2,263.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.28,257.84c1,1.75,1.92,3.53,2.87,5.31l2.79,5.42a24.9,24.9,0,0,0-1.42-6,39.66,39.66,0,0,0-2.56-5.63,44.52,44.52,0,0,0-3.37-5.17,32.64,32.64,0,0,0-4.13-4.59c.91,1.86,1.9,3.63,2.89,5.4S270.33,256.07,271.28,257.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,267.29c2.75,7.4,12.62,12.55,17,13.56l5.21,28.32.2,29.43,2.2-29.06L243.86,275S231.85,274.24,225.14,267.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,332.91c-.08-4.07.14-20.32.35-24.45l1.43-24.78c-1.24,8.19-2.19,16.42-2.92,24.67s-.66,16.51-.65,24.88c.32,8.33.28,16.54,1,24.79s1.58,16.48,2.59,24.7q-.4-12.42-1.1-24.8S225.73,337,225.62,332.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.49,367.85c-1.7-9.34-3.52-18.7-5.34-28s-3-18.7-4.31-28.1-2.45-18.84-3.81-28.25c.62,9.49,1.35,19,2.33,28.42s2.16,18.91,3.91,28.28S269,358.85,271,368.14s4.07,18.56,6.28,27.81Q275.08,381.87,272.49,367.85Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.82,184.59c-7.43,2.17-8.89,2.28-12.87,4.65s-7.09,5.83-15.39,24.56c-3.94,8.9-7.51,22.68-4.27,26.33s12.12,3.11,12.12,3.11l4-9.83Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,184.59c-7.43,2.17-8.89,2.28-12.87,4.65s-7.09,5.83-15.39,24.56c-3.94,8.9-7.51,22.68-4.27,26.33s12.12,3.11,12.12,3.11l4-9.83Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41,225.31A25.39,25.39,0,0,0,209,230.9s2.34-6.1,13.62-8.45Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.66,181.13l14.75,4.71c2.53.89,12.07,6.82,8.61,21.23-1.15,4.76-2.71,11.45-4.12,18.13-1.08,5.11,2.67,15,5.64,30.7,0,0-12.76,10-37.93,7-19.2-2.32-21.23-9.53-21.23-9.53.67-17.89,2.31-24.79,2.33-31.59a16.37,16.37,0,0,1-2.86-9.53c-.07-6.38,1.63-9.8,7.4-17,5.5-6.84,8.87-10.41,8.87-10.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,160.65c-3.5,7.09-7.35,9.62-10.61,16-7.92-.5-17.42-13.28-26.44-18.82-5.27-3.24-8.66-7.23-7-13.6,2.72-10.47,11.54-15.83,26.41-12.23,6,1.47,12.6,6.5,13.63,13.36C276.8,148.19,275.86,155.9,273.51,160.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.47,143.06c-1.6.68-4.24,4.35-5.19,18.84-.77,11.73,3.2,16,5.46,17.12a19.48,19.48,0,0,0,7.77,1.33l-.11,4.25c-3.27,2.52-5,9.24-2.79,14.71,10.21-2.41,17.26-7.76,20.17-12.79l.29-13.61s2.8,2.37,6.66-.41c3.18-2.29,3.89-7.1,1.82-9.65a5.33,5.33,0,0,0-8.49.81s-4.68,3-4.11-4.42c.65-8.33-2.41-16.81-8.17-15.24C240.46,146.81,240.76,141.58,237.47,143.06Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.51,180.35c3.81-.14,11.5-2,13.52-6.08,0,0-.53,3.6-3,5.34-3.84,2.66-10.53,3.19-10.53,3.19Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.79 155.99 243.19 166.68 238.51 164.38 244.79 155.99",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,168.5l-5.8,1.8a3,3,0,0,0,3.75,2.11A3.18,3.18,0,0,0,249,168.5Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,172.41a2.66,2.66,0,0,1-.37.07,2.76,2.76,0,0,1,2.52-2.91A3.13,3.13,0,0,1,247,172.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,157.71c-.38.83.2,1.17,1,1.52s1.53.61,1.9-.22a1.59,1.59,0,1,0-2.89-1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.93,157.24a4,4,0,0,0-1.15-.54,3.6,3.6,0,0,0-1.22-.17,4,4,0,0,0-1.28.25s-.07.1,0,.1c.34,0,.64,0,1.13,0a6.34,6.34,0,0,1,1.36.29,5.83,5.83,0,0,1,1.5.72l.48.32s.09-.08.07-.12A2.79,2.79,0,0,0,238.93,157.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,152.61l-3.69,1.19a2,2,0,0,1,1.3-2.5A1.88,1.88,0,0,1,239,152.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,158.85c.22.88-.4,1.11-1.25,1.33s-1.61.32-1.83-.56a1.59,1.59,0,1,1,3.08-.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.17,157.88a3.93,3.93,0,0,1,1.22-.32,3.18,3.18,0,0,1,1.23,0,3.74,3.74,0,0,1,1.22.48s0,.11,0,.1c-.34-.07-.63-.15-1.11-.21a6.3,6.3,0,0,0-3,.49c-.16.06-.49.21-.52.23s-.08-.1-.05-.14A2.71,2.71,0,0,1,249.17,157.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.64,153l3.43,1.81a2,2,0,0,0-.84-2.69A1.89,1.89,0,0,0,249.64,153Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.15,229.9c-.44,4.26-1.05,9.59-1.49,17.42a97.58,97.58,0,0,0,11-1s9,8.09,28.14,13a90.81,90.81,0,0,0,9,1.57c7.11-2.18,10.7-5,10.7-5-1.61-8.48-3.43-15.25-4.61-20.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,182.7c-.69.25-7.63,1.89-7.63,1.89-7.81,6.5-12.89,14.14-14.81,18.48-2.31,5.21-2.66,11-2.86,19.18-.17,7.14-2.25,28-2.33,38.43.75,2.76,5.41,5.39,5.41,5.39.3,3.63,2.15-35.7,4.24-54.69,2.63-16.72,15.13-24.89,17.94-26.79Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.45,182.7c-.69.25-7.63,1.89-7.63,1.89-7.81,6.5-12.89,14.14-14.81,18.48-2.31,5.21-2.66,11-2.86,19.18-.17,7.14-2.25,28-2.33,38.43.75,2.76,5.41,5.39,5.41,5.39.3,3.63,2.15-35.7,4.24-54.69,2.63-16.72,15.13-24.89,17.94-26.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.27,185.51c-.81.79-1.64,1.55-2.47,2.33s-1.67,1.51-2.5,2.28l.09-.3.62,2.1.06.2-.17.15q-3.14,2.79-6.33,5.5l.14-.25c-.39,2.42-.76,4.85-1.18,7.27l-1.21,7.28c0-1.24.13-2.46.23-3.69s.24-2.45.38-3.67c.26-2.45.6-4.89,1-7.32l0-.15.12-.1q3.17-2.73,6.41-5.4l-.11.36-.5-2.13-.05-.18.14-.11c.88-.7,1.75-1.42,2.65-2.11S238.36,186.18,239.27,185.51Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,181.85l-.06,2.63c-3.79,12.13-3,27.15-3.2,38.53-.37,23.89,2.91,49.29,2.91,49.29s15,2.78,21.8-6.3c0,0-3.84-14.61-6-28.48-1.28-8.22,4.34-28.26,3-40.16-.55-5-1.85-9.1-5.57-10.3C272.71,186.07,262.88,181.85,262.88,181.85Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.88,181.85l-.06,2.63c-3.79,12.13-3,27.15-3.2,38.53-.37,23.89,2.91,49.29,2.91,49.29s15,2.78,21.8-6.3c0,0-3.84-14.61-6-28.48-1.28-8.22,4.34-28.26,3-40.16-.55-5-1.85-9.1-5.57-10.3C272.71,186.07,262.88,181.85,262.88,181.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.63,220.64a32.73,32.73,0,0,1,1.21-5.27c.54-1.72,1.14-3.43,1.78-5.11s1.34-3.35,2.05-5,1.43-3.3,2.22-4.93v.32l-2.5-6.79-.09-.25.2-.15L267.7,191l-.08.28c-.36-1.21-.73-2.41-1.07-3.63s-.69-2.43-1-3.65c.45,1.18.88,2.37,1.31,3.55s.85,2.38,1.27,3.57l.06.17-.15.12-3.1,2.62.11-.4,2.61,6.76.06.15-.08.17c-.74,1.62-1.52,3.25-2.25,4.89s-1.44,3.29-2.14,4.94-1.38,3.31-2,5A37.74,37.74,0,0,0,259.63,220.64Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,227.77c-2-3.76-4.63-8.55-5.87-11.25s-1.49-3.14-3.57-4.53a59.31,59.31,0,0,0-6.06-3.62c-1.07-.54-1.35.73-.6,2.33.66,1.4,3.95,3.3,3.95,3.3s-2.92-.2-4.25-.2a12.13,12.13,0,0,0-3.71,1.26c-1.49.63-1.63,1.12-1.26,1.59s1,.89,2.54.73S217,217,217,217l3.3.35.35.45s-2.21.26-4,.68a8.7,8.7,0,0,0-3.49,1.65c-1.36.86-2.2,1.28-2.26,1.64s.1,1.36,1.9,1.21a8.92,8.92,0,0,0,3.47-1.18l3.84-.46,1.8,1.51s-2.18.12-3.44.27a16.16,16.16,0,0,0-4,1.31c-.51.31.22,1.44,1.21,1.75s3.59-.64,5-.38a29.54,29.54,0,0,1,3.88,1.27Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.9,227.77l-.86-1.64a74.67,74.67,0,0,1-7.76-.52,16.72,16.72,0,0,0-4.77.12h0a3.52,3.52,0,0,1,.48,0c1.4.27,4.49,1.31,4.49,1.31Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.41,220.53a15.4,15.4,0,0,1-1.54-1.88c-.47-.67-.87-1.38-1.32-2a5.31,5.31,0,0,0-1.6-1.7,7.53,7.53,0,0,0-2.2-.92,5.63,5.63,0,0,1,2.35.68,5,5,0,0,1,1.76,1.73c.44.69.84,1.39,1.25,2.08S227,219.85,227.41,220.53Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.83,223a12.08,12.08,0,0,1-1.87-1.31c-.59-.48-1.14-1-1.71-1.5s-1.09-1.07-1.65-1.56a3.06,3.06,0,0,0-2-.9,2.74,2.74,0,0,1,2.16.68c.62.47,1.14,1,1.72,1.5C225.61,221,226.67,222,227.83,223Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.81,224.56c-.69-.31-1.27-.76-1.9-1.08a4.45,4.45,0,0,0-1-.44,6.72,6.72,0,0,0-1.05-.24,2.81,2.81,0,0,1,1.12,0,3.78,3.78,0,0,1,1.08.39A7.32,7.32,0,0,1,225.81,224.56Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.15,233.72c-1.88-.31-4.81-.77-8.87-1.28-3.5-.45-18.26-3.58-21.78-3.86l-11.76,8.27c3.16,2,11.71,5.43,16.13,7.05,6.33,2.3,13.62,4.94,20.13,7C258.9,245.21,261.83,237.12,265.15,233.72Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,228.58l-11.76,8.27c3.16,2,11.71,5.43,16.13,7.05l4.14,1.5c5.74-2.14,13-6.1,19.8-8.54l.15-.13a15.51,15.51,0,0,1,2.19-3c-1.88-.31-4.81-.77-8.87-1.28C252.78,232,238,228.86,234.5,228.58Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,199.76c-1.45-7.34-4.31-11.47-11.35-12.7-6.53,2.56-8.13,14.38-8.11,27.26l1.9,19.43a21.5,21.5,0,0,1-4.42,0c-3.32,3.4-6.93,11.8-6.83,17.49a94.25,94.25,0,0,0,16.46,2.32c7.15.14,13.41,0,14.05-6.67a147.75,147.75,0,0,0,.09-26.55C288.06,207.92,288.14,204.84,287.13,199.76Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,199.76c-1.45-7.34-4.31-11.47-11.35-12.7-6.53,2.56-8.13,14.38-8.11,27.26l1.9,19.43a21.5,21.5,0,0,1-4.42,0c-3.32,3.4-6.93,11.8-6.83,17.49a94.25,94.25,0,0,0,16.46,2.32c7.15.14,13.41,0,14.05-6.67a147.75,147.75,0,0,0,.09-26.55C288.06,207.92,288.14,204.84,287.13,199.76Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.81,236.86a25.92,25.92,0,0,1,4.88-.79c4.65-.54,10.71,1,12.08,3.93,0,0-1.62-5-10.2-6.25a37.73,37.73,0,0,1-4.71.3A18.6,18.6,0,0,0,262.81,236.86Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.16,237.12c-4.88,1.28-23.34,6.62-40.34,6.13-1.19-2.05-1-5.71,0-9.11,1.38-4.76,2.95-6.82,5.18-8.43,13.39,1.77,22.58.52,36.39,1.73,5.67.5,13,4.41,13,4.41l.19,1.9S260,235.84,255.16,237.12Z",
    style: {
      fill: "#ffbda7"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.69,177.7a1.46,1.46,0,0,0-1.49.94c-.25-.14-.42-.41-.69-.46s-.6.27-.77.56a6.24,6.24,0,0,0,1,7.27,1.08,1.08,0,0,0,.39.28,1.14,1.14,0,0,0,.55,0,13.4,13.4,0,0,0,2.83-.86,3.22,3.22,0,0,0,2.05-2,3.56,3.56,0,0,0-.38-2.08,5.5,5.5,0,0,0-1.52-2.33C131.15,178.63,130.33,177.77,129.69,177.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,157.3c6.16-10.09,5.88-12,2.89-16.9-1.63-2.67-9.11-11.37-17.19-20.1-8.91-9.61-13-10.55-18-11l3.72,21.18,14.88,18.08s-6.49,16-7.56,20.48c-1.54,6.4.5,14.16,5.88,17.46s6.63,3.65,10.4,2.29,4.73-1.88,4.9-3.22c.44-3.37.9-3.85-1.34-5.44-1.28-.91-2.38-1.83-3.06-2.21a.59.59,0,0,0-.81.3c-.82,2,2.13,4.33,2.13,4.33a15.82,15.82,0,0,0-3.65,1.8c-1-3.34-.48-5.39-1.4-7.08-.59-1.07-1.66-2.87-1-3.92C128,171.11,132,163.6,135.84,157.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,148.57c2.93,2,6.92,1.52,8.79.81a8.86,8.86,0,0,1-9.28.34",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,107.87c7.24.07,10,1,17.2,9,3.85,4.24,18.86,21.22,20.67,24.75s1.86,5.65-1.2,11.18c-3.22,5.8-5.4,9.19-5.4,9.19s-3.82-3.13-15-3.62l3.48-9.58-15.94-15.22Z",
    style: {
      fill: "#263238"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.77,148.76c1.8,2.05,8,1.82,10.44,1-3,2.8-8.72,2.59-11,.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.72,312.71s-4.46.73-7,4-8.23,13-9.35,14.07a8.18,8.18,0,0,0,2.54,2.66l3-3.43c.75-.62,1.07-1.3,1,.72s-.33,4.1-.28,7.1c0,2.38-.45,6.89,3.63,11.46,3.82,4.27,7.92,6.31,10.77,6.72,1.7.23,4.69-.16,4.5-3.55-.1-1.79-.92-7.69-1.21-11S56.72,312.71,56.72,312.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.51,331.34c.14,2-.27,8,6.26,13.47,3.21,2.67,5.6,2.09,5.62-1,0-4.9-.61-13.9,5-23.09,1.92-3.14,7.3-9.4,14-17.11v.17c6.19-7.2,13.29-15.51,19.75-23.69l.24-.3.16-.2c6.7-8.45,12.7-16.82,16.22-23.74l.51-1a.31.31,0,0,1,0-.1h0c1.77-3.64,2.73-6.76,2.57-9.11l-15.8.29-12-8a116.29,116.29,0,0,1-8.4,18.89c-3,5.56-12.63,16.46-18.42,31.24-4.5,11.48-8.12,18.94-9,20.36s-2.67,4.46-3.24,5.18C52.72,317.84,51.81,320.85,52.51,331.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.41,246.18l27.45-.51a7.37,7.37,0,0,1,0,.94c0,.12,0,.25,0,.37s0,.43-.07.65-.06.33-.09.49-.07.39-.11.59-.1.4-.15.6-.09.35-.15.54a1,1,0,0,1-.05.16c-.11.07-6.94,4.75-19.78,6.94,0,0-.41,20.49-3.8,28.75l0,0,0,0c-1.26,1.55-2.54,3.09-3.81,4.63C94.24,278.07,95.41,246.18,95.41,246.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,334.64a13.69,13.69,0,0,0-3.74,7.7c-.38,4.43.15,16.56-.2,18.19a7.55,7.55,0,0,0,3.57.92l.68-4.87c.3-1,.19-1.8,1.26,0s2,3.9,3.63,6.58c1.33,2.13,3.36,6.5,9.27,8.24,5.53,1.63,10.08,1.08,12.69-.22,1.56-.78,3.85-2.89,1.85-5.84-1.06-1.56-4.94-6.42-7-9.22S76.18,334.64,76.18,334.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.19,334.49c-.28-11.59,10.63-64.59,7.69-89.49l-31.12-.37a135.11,135.11,0,0,1,3.22,22c.51,6.77-1.67,22.27,1.5,39,2.46,13,3.47,21.88,3.51,23.67s.19,5.59.11,6.58c-.5,5.72.37,9,6.66,18.06,1.21,1.75,4.13,7.41,12.57,8.52,4.15.54,5.84-1.39,4.19-4.17C96.89,353.84,91.46,346.08,91.19,334.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,266.62c.06,2.64-.09,5.26-.24,7.88s-.24,5.26-.31,7.89A124.58,124.58,0,0,0,71,298.2c.28,2.63.71,5.23,1.19,7.82l1.43,7.73c.47,2.58.9,5.17,1.31,7.76s.82,5.18,1.07,7.8a152.06,152.06,0,0,0-1.78-15.67c-.76-5.22-1.95-10.33-2.42-15.54-.31-2.59-.47-5.21-.6-7.83S71.06,285,71,282.4s0-5.25.09-7.88S71.22,269.25,71,266.62Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.33,258.86A98.83,98.83,0,0,0,98.88,245l-31.12-.37a99.41,99.41,0,0,1,2,10.46h0S81.72,261.12,99.33,258.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,194.37a183.31,183.31,0,0,0-3.37-21.27c-1.24-5.37-2.4-10-3.22-14.14-9,6-31.53,6.57-41.88-.21-1.73,2.71-6.87,9.48-10.95,19.1-3.55,8.4-5,13.66-4.85,24.1.15,9.56,4.42,37.65,8.31,49.65,10.51,5.83,47.38,4.49,57.82-5.95C124.16,245.65,123.54,204.27,122.3,194.37Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hair--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.22,91.37c-.93-1.34-1.35-4.1-.34-5.38a6.52,6.52,0,0,1,3.79-2.27,3.43,3.43,0,0,0,2.81-3.93c.08-3,.94-4.67,2.52-5.84,4.26-3.11,15.67-3.49,15.36,4.14,0,1.14-.42,2.38.19,3.34a3.39,3.39,0,0,0,1.08,1,27.85,27.85,0,0,1,5.66,4.31c1.58,1.79,2.56,4.33,1.78,6.58s-2.87,3.62-3.24,5.83c-.5,3,2.55,6,1.72,8.92-.67,2.37-2.58,2.89-4.66,3.19-2.4.36-3.21,3.32-6,3.13a15,15,0,0,0-3.57.47,10.16,10.16,0,0,1-4.39,0,5.55,5.55,0,0,1-3.49-2.53c-.66-1.18-.78-2.67-1.7-3.67s-1.89-1.32-2.72-2.12a5,5,0,0,1-1.74-3A3.13,3.13,0,0,1,56,101a2.12,2.12,0,0,0-1.47,1.92,6.08,6.08,0,0,0,.45,2.52,5.38,5.38,0,0,1-2.24-7.77c.54-.83,1.33-1.6,1.33-2.58C54,93.5,53.12,92.68,52.22,91.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,71.58c-4.25,2.35-3.89,10.6,1.4,14.11S74.19,67.57,67.8,71.58Z",
    style: {
      fill: "#90CAF9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.52,64.74c-.83-5.5-7.06-5.7-8.71-5.5a7.86,7.86,0,0,1-6.41-2.65,7.9,7.9,0,0,0-7.65-2.22c-4.42,1.18-3.39,3-7.13,4.32-3.33,1.15-5.81.07-8.84,3A8.64,8.64,0,0,0,70.57,69c-2.28,1.42-5.28,9.83-.54,19,2.44,4.72,5.34,6.91,9,10.81h3.49c1.12-3,4.09-2.43,6.81-3.13,1.73-.79,2.7-2.74,4.43-3.53s3.83-.23,5.73-.58c1.47-.26,3-1.15,4.5-.78,3.51,1.4,8.77-1.68,8.34-5.72-.14-1.22-.82-2.4-.59-3.61.3-1.59,2-2.48,2.87-3.82a4.22,4.22,0,0,0-.28-5.06C111.77,69.84,112,67.87,111.52,64.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.42,109l-1.82-.21c-1.55-.18-1.43-1.95-1.59-3.47l-.16-2.37a10.52,10.52,0,0,0,7.74-2.52c3.19-2.82,4.86-8.4,4.5-14.38-.24-4-1.28-5.83-1.23-6.72.3-5.33-.13-6.28-1.39-9-2.27-4.37-7.9-5.92-10.28-1.19-7-5.36-14.61,1.82-14.25,10,1,6.77-1.09,7.13-2.41,7.18-2-4.21-6.36-4.11-8.18-1.36-1.65,2.48-1.57,6.29,1.67,9.73s6.64,1.15,6.67.47c0,0,.59,9.13.68,11s-.1,2.89-2.36,3.66h0l-3.25,1.1s.18.23.54.62c.82.94,2.64,3,5.7,6.59,7.74,2.83,17,6.78,22.46,10a99.54,99.54,0,0,0,3.41-12A43.31,43.31,0,0,0,99.42,109Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.48,
    cy: 93.14,
    r: 1.61,
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,91.42l5.19,1.34a2.64,2.64,0,0,1-3.21,2A2.82,2.82,0,0,1,91.46,91.42Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.85,92.58a3,3,0,0,1,3.08,2.13,2.6,2.6,0,0,1-1.49.07,2.76,2.76,0,0,1-2-2.13A2.66,2.66,0,0,1,91.85,92.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13,76.54l-4-1A2,2,0,0,1,103.59,74,2.16,2.16,0,0,1,105.13,76.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.91,78l3.81-1.71A2,2,0,0,0,87,75.23,2.18,2.18,0,0,0,85.91,78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46,80.78a1.72,1.72,0,0,0,1.65,1.74,1.63,1.63,0,0,0,1.72-1.58,1.73,1.73,0,0,0-1.65-1.75A1.63,1.63,0,0,0,100.46,80.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.27,81.38A1.77,1.77,0,0,0,90,83.16a1.67,1.67,0,0,0,1.76-1.62A1.77,1.77,0,0,0,90,79.76,1.65,1.65,0,0,0,88.27,81.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.85,102.9c-6.56-.29-12.92-1.74-14.73-5.64a6.71,6.71,0,0,0,4,5.36A23.63,23.63,0,0,0,96,104.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.77 86.24 95.88 88.78 94.49 77.54 101.77 86.24",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.58,108.71s2.9,6.06.92,9.72c-9.79-1.12-18.06-5.67-21.4-8.74L68.87,111s-5.39,10.28-3.72,19,8.68,28.74,8.68,28.74c9.32,13.53,41,6.38,41.88.21,0,0,.94-7.67,1.72-14,0,0,4.44-4.26,4.66-10,.23-6-2.24-10.18-8.28-16.36a74,74,0,0,0-11.46-9.71Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.58,108.71s2.9,6.06.92,9.72c-9.79-1.12-18.06-5.67-21.4-8.74L68.87,111s-5.39,10.28-3.72,19,8.68,28.74,8.68,28.74c9.32,13.53,41,6.38,41.88.21,0,0,.94-7.67,1.72-14,0,0,4.44-4.26,4.66-10,.23-6-2.24-10.18-8.28-16.36a74,74,0,0,0-11.46-9.71Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.86,143.71a12.6,12.6,0,0,0,10.85,8.35,13.31,13.31,0,0,0,12.23-5.32s-1.71,9.12-12.56,7.52S79.86,143.71,79.86,143.71Z",
    style: {
      fill: "#90CAF9",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33,106.2s8.08,18.81,10.8,27.89,1.31,16.33.29,32.76c-.79,12.65-2.17,31.73-2.17,31.73s-24-.35-31.36-11c2-6.29,8.11-20.95,9.7-25s.81-7.55-1.76-16.83-6.68-14.35-6.56-21.21,4.9-12.4,6.65-13.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.36,107.76a1.4,1.4,0,0,0,1,.93s16.27,15.65,17.41,31.86,2.15,51.72,2.15,51.72,1.77-.82,5.21-4.58c-.73-7.36-3.27-36.44-2.58-39.77s8.62-10.92,1.34-21.74S102,107.88,102,107.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.34,111.71c1,.93,2.06,1.87,3,2.84,2,1.94,4,3.89,5.9,5.91.95,1,1.9,2,2.82,3.09.47.53.92,1.06,1.36,1.61a5.51,5.51,0,0,1,1.15,1.93,6.34,6.34,0,0,1,.13,2.24,13.12,13.12,0,0,1-.4,2.11,26.91,26.91,0,0,1-1.33,3.75,17,17,0,0,1,2.74,4.5,3.53,3.53,0,0,1,.17.73,3.68,3.68,0,0,1,0,.75c0,.47-.12.92-.19,1.37-.15.9-.33,1.78-.52,2.67-.76,3.53-1.67,7-2.65,10.49.7-3.54,1.41-7.07,2-10.61.16-.89.3-1.77.42-2.66,0-.44.11-.88.13-1.31a2.48,2.48,0,0,0-.14-1.18,17.14,17.14,0,0,0-2.82-4.4l-.17-.21.11-.26a24.66,24.66,0,0,0,1.33-3.85,12.7,12.7,0,0,0,.36-2,5.05,5.05,0,0,0-.08-1.91,4.53,4.53,0,0,0-1-1.62c-.42-.54-.86-1.07-1.31-1.59-.89-1.05-1.83-2.08-2.76-3.11-1.87-2.05-3.75-4.09-5.68-6.09s-3.82-4-5.87-5.91C102.26,109.85,103.3,110.78,104.34,111.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.75,133.22V126.6c.06-5.89.12-11.77.33-17.66.25,5.89.37,11.78.48,17.68l0,4.43,0,2.21v.54a1.52,1.52,0,0,0,.06.42,2.26,2.26,0,0,0,.45.79,10.17,10.17,0,0,0,3.5,2.26,30,30,0,0,0,4.09,1.43l.48.13-.17.46a48.55,48.55,0,0,0-1.85,5.45c-.12.46-.23.93-.31,1.38a3.53,3.53,0,0,0,0,1.28l0,.12.08.17L84.07,150c.86,1.74,1.74,3.47,2.57,5.22l2.52,5.25-2.85-5.08c-1-1.69-1.86-3.4-2.79-5.11L82.83,149l-.35-.64-.26-.48-.07-.23a3.77,3.77,0,0,1,0-1.6,11.43,11.43,0,0,1,.29-1.46,48.06,48.06,0,0,1,1.65-5.14,29.15,29.15,0,0,1-3.79-1.29,10.41,10.41,0,0,1-3.84-2.53,3.16,3.16,0,0,1-.61-1.13,2.58,2.58,0,0,1-.08-.68Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.92,111c-7.85,1.37-11,6.17-14.42,16.36C45.78,141.25,41.64,155,40.75,162l18.52-5.07,9.91-19.94S72.89,120.93,64.92,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.46 189.36 62.4 183.2 56.3 131.83 96.37 137.99 102.46 189.36",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.46 189.36 62.4 183.2 56.3 131.83 96.37 137.99 102.46 189.36",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.98 187.11 62.59 181.19 56.91 133.29 95.3 139.2 100.98 187.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,172.6l-3.84-32.35L56.3,131.82l6.1,51.39,38,8.91a1,1,0,0,0,1.21-1.11l-1.94-16.39a1.82,1.82,0,0,0-1.32-1.49Z",
    style: {
      fill: "#90CAF9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41,162c0,5.26.78,6.14,6.56,9.1s20.36,7.52,31.9,8.63c7.53.73,11.4.37,14.32-.78a12.09,12.09,0,0,0,7.54-13.24c1.26-3.63-.65-4.12-2.21-4.52l.28,2.38s-3.38,2.3-6.49,2.34-.22-3.6.34-5.8.44-3.46-1.36-4.5c-1,0-1.34,1.38-4.48,4.51-2.38,2.37-4.24,6.7-7.94,6.2-2.89-.4-20.08-8.37-20.08-8.37l-.78-6.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75,162c-.22,3.28.36,5,1.87,6.41s7.76,4.36,11.6,5.7,13.9,4.06,15.82,4.41c-2-3.12-1.51-9.27.19-12s3.93-2.09,3.93-2.09l-14.79-6.65-1.07-9Z",
    style: {
      fill: "#263238"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.42,78.32a25.32,25.32,0,0,1,2,18.5l-.93,2.74A25.31,25.31,0,0,1,189.3,84.62l.79-2.79a25.31,25.31,0,0,1,46.33-3.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.2,65.81a27.47,27.47,0,0,0,21.38,50.41l6.44,5.61a1.59,1.59,0,0,0,2.63-1.39l-1-8.48A27.47,27.47,0,0,0,201.2,65.81Zm35.22,12.51a25.32,25.32,0,0,1,2,18.5l-.93,2.74A25.31,25.31,0,0,1,189.3,84.62l.79-2.79a25.31,25.31,0,0,1,46.33-3.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.42,78.32a25.32,25.32,0,0,1,2,18.5l-.93,2.74A25.31,25.31,0,0,1,189.3,84.62l.79-2.79a25.31,25.31,0,0,1,46.33-3.51Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.39,95.53l-6.46-13.22a1.21,1.21,0,0,0,.3-.79,1.24,1.24,0,0,0-2.36-.52h-9.23V76.89a2.14,2.14,0,1,0-1.36,0V81h-9.23a1.24,1.24,0,0,0-2.36.52,1.21,1.21,0,0,0,.3.79l-6.46,13.22h-.44c.08.21.19.41.29.61a.33.33,0,0,0,0,.06,8.37,8.37,0,0,0,15.05,0l0,0c.1-.21.21-.41.29-.62h-.44l-6.46-13.22a.9.9,0,0,0,.17-.26h9.23v20.66h-2.4v1h-.62a2.15,2.15,0,0,0-2.15,2.15h11.7a2.15,2.15,0,0,0-2.15-2.15H217v-1h-2.4V82.05h9.23a1.17,1.17,0,0,0,.17.26l-6.46,13.22h-.36c.06.14.13.27.2.41a.46.46,0,0,0,.23.47,8.4,8.4,0,0,0,15.27-.88Zm-23.16,0H196.64l6.25-12.77H203Zm9.46,0,6.25-12.77H225l6.25,12.77Z",
    style: {
      fill: "#90CAF9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawFirmAmico);
export default __webpack_public_path__ + "static/media/Law-firm-amico.29f99e569e1eac557cd7f975828867a2.svg";
export { ForwardRef as ReactComponent };